'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

angular.module('admin', ['tandibar/ng-rollbar', 'ui.router', 'homebot.directives', 'homebot.filters', 'homebot.services', 'sharedservices', 'admin.services', 'admin.directives', 'ngCookies', 'ngAnimate', 'ngStorage', 'ngSanitize', 'jsonFormatter', 'bw.paging', 'text-mask', 'appTemplateCache', 'adminTemplateCache']).config(['$stateProvider', '$urlRouterProvider', '$httpProvider', '$locationProvider', '$compileProvider', function ($stateProvider, $urlRouterProvider, $httpProvider, $locationProvider, $compileProvider) {
  $urlRouterProvider.otherwise("/start");

  $locationProvider.html5Mode(true);
}]).constant('API_VARS', {
  path: window.HB_APP_CONFIG.API_URL + 'v1',
  app: 'HomebotAdmin',
  loginTTL: 28
}).constant('APP_CONFIG', window.HB_APP_CONFIG).constant('FEATURES', {
  DIGEST_V2: 'digest_v2',
  MORTGAGE_COACH: 'mortgage_coach_customer',
  ADMIN: 'legacy_customer_admin'
}).config(['RollbarProvider', 'APP_CONFIG', function (RollbarProvider, APP_CONFIG) {
  if (!APP_CONFIG.ROLLBAR_ENV) return;

  RollbarProvider.init({
    accessToken: 'd601b21d78ec42e0a0d4e300c1d7933e',
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: APP_CONFIG.ROLLBAR_ENV
    }
  });
}]).config(['JSONFormatterConfigProvider', function (JSONFormatterConfigProvider) {
  // Enable the hover preview feature
  JSONFormatterConfigProvider.hoverPreviewEnabled = true;
}])

// Add Authorization header to each request
.config(['$httpProvider', function ($httpProvider) {
  $httpProvider.interceptors.push('AuthHeaderInterceptor');
}]).run(['AccountService', 'SessionService', function (AccountService, SessionService) {
  if (SessionService.isLoggedIn()) AccountService.initIntercom();
}])

// Most often triggered by users that aren't logged in
// See the `authenticated` blocks in the routers
.run(['$rootScope', '$state', 'AuthForwarder', 'SessionService', 'PageNotificationService', function ($rootScope, $state, AuthForwarder, SessionService, PageNotificationService) {
  $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, options) {
    if (!SessionService.isLoggedIn()) {
      if (toState.name !== 'agent.login') {
        var forwardState = $state.href(toState, toParams, { absolute: true });
        AuthForwarder.setForwardState(forwardState);
        $state.go('login');
      }
    } else {
      PageNotificationService.error('There was an error loading this page.');
    }
  });
}])

// Allow routes to be set to external urls
.run(['$rootScope', '$window', 'APP_CONFIG', function ($rootScope, $window, APP_CONFIG) {
  $rootScope.$on('$stateChangeStart', function (event, toState, toParams) {
    if (toState.external && !toState.waitForResolve) {
      event.preventDefault();

      if (Object.keys(toParams).length > 0) {
        if (toState.externalUrl.includes("{groupId}") && toParams.groupId) {
          toState.externalUrl = toState.externalUrl.replace('{groupId}', toParams.groupId);
        }

        if (toState.externalUrl.includes("{homeId}") && toParams.homeId) {
          toState.externalUrl = toState.externalUrl.replace('{homeId}', toParams.homeId);
        }

        if (toState.externalUrl.includes("{clientId}") && toParams.clientId) {
          toState.externalUrl = toState.externalUrl.replace('{clientId}', toParams.clientId);
        }
      }

      if (toState.externalUrl.indexOf(APP_CONFIG.MAINSTREET_URL) === 0 || toState.externalUrl.indexOf(APP_CONFIG.CLIENTS_FRONTEND_URL) === 0) {
        $window.open(toState.externalUrl, '_self');
      }
    }
  });

  // duplicate this on stateChangeSuccess to account for waiting for resolve functions
  // otherwise angular will navigate to the fallback (.otherwise) route
  // and create extra calls and an extra history item
  $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams) {
    if (toState.external && toState.waitForResolve) {
      event.preventDefault();

      if (Object.keys(toParams).length > 0) {
        if (toState.externalUrl.includes("{groupId}") && toParams.groupId) {
          toState.externalUrl = toState.externalUrl.replace('{groupId}', toParams.groupId);
        } else if (toState.externalUrl.includes("{homeId}") && toParams.homeId) {
          toState.externalUrl = toState.externalUrl.replace('{homeId}', toParams.homeId);
        }
      }

      if (toState.externalUrl.indexOf(APP_CONFIG.MAINSTREET_URL) === 0 || toState.externalUrl.indexOf(APP_CONFIG.CLIENTS_FRONTEND_URL) === 0) {
        $window.open(toState.externalUrl, '_self');
      }
    }
  });
}]);

angular.module('admin.directives', []).directive('customOnChange', function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var onChangeHandler = scope.$eval(attrs.customOnChange);
      element.bind('change', onChangeHandler);
    }
  };
}).directive('contenteditable', ['$timeout', function ($timeout) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function link(scope, element, attrs, ngModel) {
      // don't do anything unless this is actually bound to a model
      if (!ngModel) {
        return;
      }

      // view -> model
      element.bind('input', function (e) {
        scope.$apply(function () {
          var html, html2, rerender;
          html = element.html();
          rerender = false;

          html = html.replace(/<br>$/, '');
          html2 = html.replace(/<div>/g, '').replace(/<br>/g, '').replace(/<\/div>/g, '');

          if (html2 !== html) {
            rerender = true;
            html = html2;
          }

          ngModel.$setViewValue(html);
          if (rerender) {
            ngModel.$render();
          }
          if (html === '') {
            // the cursor disappears if the contents is empty
            // so we need to refocus
            $timeout(function () {
              element[0].blur();
              element[0].focus();
            });
          }
          // scope.checkClientErrors();
        });
      });

      // model -> view
      var oldRender = ngModel.$render;
      ngModel.$render = function () {
        var el, el2, range, sel;
        if (!!oldRender) {
          oldRender();
        }
        element.html(ngModel.$viewValue || '');

        el = element[0];
        range = document.createRange();
        sel = window.getSelection();
        if (el.childNodes.length > 0) {
          el2 = el.childNodes[el.childNodes.length - 1];
          range.setStartAfter(el2);
        } else {
          range.setStartAfter(el);
        }
        range.collapse(true);
        sel.removeAllRanges();
        sel.addRange(range);
      };

      element.bind('click', function (e) {

        if (element.hasClass('text-danger')) element.removeClass('text-danger');

        var range, sel, target;
        target = e.toElement;
        if (target !== this && angular.element(target).attr('contenteditable') === 'false') {
          range = document.createRange();
          sel = window.getSelection();
          range.setStartBefore(target);
          range.setEndAfter(target);
          sel.removeAllRanges();
          sel.addRange(range);
        }
      });
    }
  };
}]);

if (typeof require !== 'undefined') {
  var _EventSentenceFilter = require('./filters/event-sentence.js');
}

angular.module('admin').filter('allToDashes', function () {
  return function (str) {
    return str.replace(/[^0-9A-Z]/ig, '-');
  };
}).filter('estimateCorrect', function () {
  return function (str) {
    switch (str) {
      case 'close':
        return 'close';
      case 'toolow':
        return 'too low';
      case 'toohigh':
        return 'too high';
      default:
        return '';
    }
  };
}).filter('mapsSlug', function () {
  return function (address) {
    var unitHashed = address.unit ? '#' + address.unit : '';
    var str = address.street + ' ' + unitHashed + ' ' + address.zip;
    return _.kebabCase(str);
  };
}).filter('homeUpdateSentence', function () {
  return function (answers) {
    if (typeof answers.homeUpdated === 'undefined') return '';
    if (answers.homeUpdated === 'false') // This is a string in DB
      return 'The home has not been updated since they bought it.';
    if (answers.homeUpdated && answers.homeUpdatedScale) return 'The home has been improved with ' + answers.homeUpdatedScale + ' updates.';

    return 'The home has been updated.';
  };
}).filter('additionalUpdates', function () {
  return function (unParseableUpdatesString) {
    var noUpdateMsg = 'The home has not been updated';
    try {
      var _ret = function () {
        if (unParseableUpdatesString == null) return {
            v: noUpdateMsg
          };

        var parseable = '{' + unParseableUpdatesString + '}';
        var updates = JSON.parse(parseable);
        var completed = Object.keys(updates).reduce(function (acc, camelCaseUpdateName) {
          var updated = updates[camelCaseUpdateName];
          var humanizedUpdateName = _.snakeCase(camelCaseUpdateName).replace('_', ' ');

          return updated ? acc.concat(humanizedUpdateName) : acc;
        }, []).join(', ');

        return {
          v: completed ? 'List of updates: ' + completed : noUpdateMsg
        };
      }();

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    } catch (error) {
      Rollbar.error('had trouble parsing the list of additional updates', { error: error, unParseableUpdatesString: unParseableUpdatesString });
      return noUpdateMsg;
    }
  };
}).filter('appreciation', ['$filter', function ($filter) {
  return function (diff) {
    return diff > 0 ? 'worth ' + $filter('money')(diff) + ' more than' : diff < 0 ? 'worth ' + $filter('money')(Math.abs(diff)) + ' less than' : 'equal to';
  };
}]).filter('eventSentence', ['$filter', function ($filter) {
  return EventSentenceFilter($filter);
}]).filter('clientNames', ['HelperService', function (helpers) {
  return function (home) {
    var names = helpers.clientNameDisplay(home.users);
    return names || 'No users attached yet';
  };
}]).filter('clientNamesForwards', function () {
  return function (home) {
    var users = _.cloneDeep(home.users);

    if (!users || !users.length) return 'No users attached yet';

    if (users.length === 1) return users[0].first_name + ' ' + users[0].last_name;

    if (users[0].last_name === users[1].last_name) return users[0].first_name + ' & ' + users[1].first_name + ' ' + users[0].last_name;else return users[0].first_name + ' ' + users[0].last_name + ' & ' + users[1].first_name + ' ' + users[1].last_name;
  };
}).filter('clientFirstNames', function () {
  return function (home) {
    if (!home.users || !home.users.length) return 'No users attached yet';

    if (home.users.length === 1) return home.users[0].first_name;else return home.users[0].first_name + ' & ' + home.users[1].first_name;
  };
}).filter('userEmailIssue', function () {
  return function (user) {
    if (user.emailVerificationCode === 'spam') return 'Marked as spam';

    if (user.emailVerificationCode === 'soft_bounce' || user.emailVerificationCode === 'hard_bounce') return 'Email bounced';

    if (user.emailValid === false) return 'Invalid email';

    if (user.digestEmailUnsubscribed) return 'Unsubscribed';

    return user.emailVerificationCode;
  };
}).filter('abbreviatedMoney', function () {
  return function (number) {
    return Helpers.abbreviateMoney(number);
  };
}).filter('ratePercent', function () {
  return function (number) {
    return Math.round(number * 1000) / 1000 + '%';
  };
});

angular.module('admin.services', []).factory('AccountService', ['API_VARS', 'APP_CONFIG', '$http', '$q', '$state', 'HelperService', 'UtilService', '$cookies', function (API_VARS, APP_CONFIG, $http, $q, $state, helpers, utils, $cookies) {

  function handleResponse(response) {
    if (utils.isValidResponse(response)) return response.data;else return $q.reject(helpers.parseAPIError(response));
  };

  function handleError(response) {
    return $q.reject(helpers.parseAPIError(response));
  };

  return {
    set: function set(agent) {
      // Fix for agent cookies growing too large for browsers.
      var agentInfo = _.omit(agent, ['disclaimer', 'disclaimer_html']);
      $cookies.putObject('agent', agentInfo, { path: '/', expires: moment().add(API_VARS.loginTTL, 'day').format() });
      $http.defaults.headers.common.Authorization = agent.access_token;
    },

    getAgentId: function getAgentId() {
      return this.getAgent('id');
    },

    getAgent: function getAgent(field) {
      var agent = $cookies.getObject('agent') || {};

      if (field) return agent[field];else return agent;
    },

    hasFeature: function hasFeature(feature) {
      var agent = $cookies.getObject('agent') || { features: [] };
      return _.contains(agent.features, feature);
    },

    initIntercom: function initIntercom() {
      if (!window.Intercom) return;

      if (this.hasBootedIntercom) return;

      var agent = this.getAgent();

      if (_.isEmpty(agent)) return;

      var created = agent.created ? moment(agent.created) : moment();
      created = created.unix();

      var hasPhoto = agent.photo && agent.photo.indexOf('default-photo') === -1;

      var acceptedLegalAt = agent.legalAcceptedAt ? moment(agent.legalAcceptedAt).unix() : null;

      var opts = {
        accepted_legal_at: acceptedLegalAt,
        admin_url: 'https://www.homebotapp.com/admin/agent/' + agent.id + '/clients',
        app_id: APP_CONFIG.intercomId,
        avatar: {
          type: 'avatar',
          image_url: agent.photo
        },
        cospo_count: agent.cospoCount,
        created_at: created,
        digests_enabled: agent.digestsEnabled,
        email: agent.email,
        has_cospo: agent.hasCosponsorship,
        has_photo: hasPhoto,
        name: agent.first_name + ' ' + agent.last_name,
        pending_outgoing_invite: agent.hasPendingOutgoingInvite,
        source: agent.source,
        total_clients: agent.totalClients,
        type: agent.type,
        user_id: agent.id,
        welcome_emails: agent.welcomeEmailsEnabled
      };

      Intercom('boot', opts);

      this.hasBootedIntercom = true;
    },

    shutdownIntercom: function shutdownIntercom() {
      this.hasBootedIntercom = false;

      if (window.Intercom) Intercom('shutdown');
    }

  };
}]).factory('AgentService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function (API_VARS, $http, $q, helpers, apiHelpers) {
  var service = new BaseAPIFactory('agents', API_VARS, $http, $q, helpers, apiHelpers);

  service.realEstateAgents = function (id, mlsset) {
    var params = {};

    if (mlsset) params.mlsset = mlsset;

    return $http.get(API_VARS.path + '/agents/' + id + '/realEstateAgents', { params: params }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.sendAll = function (agentId) {
    if (!agentId) return $q.reject('Agent Id is required');

    return $http.get(API_VARS.path + '/agents/' + agentId + '/sendAll').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.importClients = function (agentId) {
    return $http.post(API_VARS.path + '/agents/' + agentId + '/buildHomesForAgent').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.getSponsor = function (agentId) {
    return $http.get(API_VARS.path + '/agents/' + agentId + '/sponsor').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.getSponsoredAgents = function (agentId) {
    return $http.get(API_VARS.path + '/agents/' + agentId + '/sponsoredAgents').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.getSponsoredAgent = function (agentId, sponsoredAgentId) {
    return $http.get(API_VARS.path + '/agents/' + agentId + '/sponsoredAgents/' + sponsoredAgentId).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.getBrokerage = function (agentId) {
    return $http.get(API_VARS.path + '/agents/' + agentId + '/brokerage').then(apiHelpers.handleResponse).catch();
  };

  service.searchHomes = function (agentId, homeownerNameOrStreet, limit, offset, sortBy, order) {
    var params = { homeownerNameOrStreet: homeownerNameOrStreet, limit: limit, offset: offset, sortBy: sortBy, order: order };

    return $http.get(API_VARS.path + '/agents/' + agentId + '/homes/search', { params: params }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.needsCMA = function (agentId) {
    return $http.get(API_VARS.path + '/agents/' + agentId + '/homes/needsCMA').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.countHomes = function (agentId, where) {
    where = where || {};

    return $http.get(API_VARS.path + '/agents/' + agentId + '/homes/countHomes', { params: { where: where } }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.getCurrentUser = function () {
    return $http.get(API_VARS.path + '/agents/currentUser').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.sharedClients = function (agentId) {
    return $http.get(API_VARS.path + ('/agents/' + agentId + '/sharedClients')).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.acceptTerms = function (agentId) {
    return $http.put(API_VARS.path + ('/agents/' + agentId + '/acceptTerms')).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  return service;
}]).factory('OfficeService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function (API_VARS, $http, $q, helpers, apiHelpers) {
  return new BaseAPIFactory('offices', API_VARS, $http, $q, helpers, apiHelpers);
}]).factory('BrokerageService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function (API_VARS, $http, $q, helpers, apiHelpers) {
  var service = new BaseAPIFactory('brokerages', API_VARS, $http, $q, helpers, apiHelpers);

  service.getOffices = function (brokerageId) {
    return $http.get(API_VARS.path + '/brokerages/' + brokerageId + '/offices').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  return service;
}]).factory('RealEstateAgentService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function (API_VARS, $http, $q, helpers, apiHelpers) {
  return new BaseAPIFactory('realEstateAgents', API_VARS, $http, $q, helpers, apiHelpers);
}]).factory('LoanService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function (API_VARS, $http, $q, helpers, apiHelpers) {
  return new BaseAPIFactory('homeLoans', API_VARS, $http, $q, helpers, apiHelpers);
}]).factory('UserService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function (API_VARS, $http, $q, helpers, apiHelpers) {
  var service = new BaseAPIFactory('users', API_VARS, $http, $q, helpers, apiHelpers);

  service.getUserHomes = function (userId) {
    return $http.get(API_VARS.path + '/users/' + userId + '/userHomesList').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.getLeads = function (agentId) {
    if (!agentId) throw 'AgentId is required for client search.';

    var params = { filter: { where: { agentId: agentId, leadSource: { neq: null } } } };

    return service.getAll(params);
  };

  service.getUsersWithEmailIssues = function (agentId) {
    if (!agentId) throw 'AgentId is required for client search.';

    var params = { filter: { where: { agentId: agentId, hasEmailIssues: true } } };

    return service.getAll(params);
  };

  return service;
}]).factory('UserHomesService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function (API_VARS, $http, $q, helpers, apiHelpers) {
  var service = new BaseAPIFactory('userHomes', API_VARS, $http, $q, helpers, apiHelpers);

  service.updateDigestStatus = function (userHomeId, digestStatus) {
    return $http.put(API_VARS.path + '/userHomes/' + userHomeId + '/updateDigestStatus', { digestStatus: digestStatus }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  return service;
}]).factory('HomeActivity', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function (API_VARS, $http, $q, helpers, apiHelpers) {
  var service = new BaseAPIFactory('homeActivities', API_VARS, $http, $q, helpers, apiHelpers);

  service.getAgentActivity = function (id) {
    return service.getActivity({ 'agentId': id });
  };

  service.getUserActivity = function (id) {
    return service.getActivity({ 'userId': id });
  };

  service.getHomeActivity = function (id) {
    return service.getActivity({ 'homeId': id });
  };

  service.getUserHomeActivity = function (userId, homeId) {
    return service.getActivity({ 'userId': userId, 'homeId': homeId });
  };

  service.getCmaRequest = function (homeId) {
    var params = {
      filter: {
        where: {
          homeId: homeId,
          event: 'cma-request'
        },
        order: 'created DESC'
      }
    };

    return $http.get(API_VARS.path + '/homeActivities', { params: params }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.getActivity = function (where, include, limit) {
    var where = where || {};
    var include = include || 'user';
    var params = {
      filter: {
        where: where,
        include: include,
        order: 'created DESC',
        limit: limit || 200
      }
    };

    return $http.get(API_VARS.path + '/homeActivities', { params: params }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.trackHome = function (args) {

    return $http.post(API_VARS.path + '/homeActivities/track/', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  return service;
}]).factory('HomeService', ['API_VARS', '$http', '$q', 'HelperService', 'AdminApiHelperService', function (API_VARS, $http, $q, helpers, apiHelpers) {
  var service = new BaseAPIFactory('homes', API_VARS, $http, $q, helpers, apiHelpers);

  service.saveAnswer = function (question, answer, homeId) {
    var args = {
      question: question,
      answer: answer
    };

    return $http.post(API_VARS.path + '/homes/' + homeId + '/addAnswer', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.saveAnswers = function (answers, homeId) {
    var args = { answers: answers };

    return $http.post(API_VARS.path + '/homes/' + homeId + '/addAnswers', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.deleteAnswer = function (answerId, homeId) {
    return $http.delete(API_VARS.path + '/homes/' + homeId + '/answerData/' + answerId).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.getAnswers = function (homeId) {
    return $http.get(API_VARS.path + '/homes/' + homeId + '/answerData').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.sendDigestTest = function (homeId, email) {
    var args = {};

    if (!homeId || !email) return $q.reject('Home and email are required to send a digest test.');

    args.email = email;

    return $http.post(API_VARS.path + '/homes/' + homeId + '/testDigest', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.sendDigest = function (id, args) {
    var defaults = {
      users: []
    };

    var args = _.merge(defaults, args);

    if (!args.users.length) return $q.reject('Users are required to send digest.');

    return $http.post(API_VARS.path + '/homes/' + id + '/digest', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.addUserToHome = function (homeId, userParams) {
    return $http.post(API_VARS.path + '/homes/' + homeId + '/addUser', { userParams: userParams }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  }, service.lookup = function (args) {
    var args = args || {};

    return $http.get(API_VARS.path + '/homes/lookup', { params: args }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.getDetailedHome = function (homeId) {
    return $http.get(API_VARS.path + '/homes/' + homeId + '/detailed/').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.getUsers = function (homeId) {
    return $http.get(API_VARS.path + '/homes/' + homeId + '/users/').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.lookupByDatasource = function (args) {
    var args = args || {};

    // The api should handle this logic in future
    if (args.source === 'homebot') return service.getDetailedHome(args.homeId);

    return $http.get(API_VARS.path + '/homes/lookup/datasource', { params: args }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.updateExternalData = function (id) {
    return $http.post(API_VARS.path + '/homes/' + id + '/updateExternalData').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.recompileHome = function (id) {
    return $http.post(API_VARS.path + '/homes/' + id + '/recompileHome').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.deleteLoans = function (id) {
    return $http.delete(API_VARS.path + '/homes/' + id + '/rloans').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.agentCMA = function (id, cma) {
    return $http.post(API_VARS.path + '/homes/' + id + '/agentCMA', cma).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.createHome = function (args) {
    return $http.post(API_VARS.path + '/homes/createHome', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.createManyHomes = function (args) {
    return $http.post(API_VARS.path + '/homes/createManyHomes', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.updateHomeProperties = function (data, homeId) {
    var args = { data: data };

    return $http.post(API_VARS.path + '/homes/' + homeId + '/updateHome', args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  service.resetCMA = function (homeId) {
    return $http.post(API_VARS.path + '/homes/' + homeId + '/resetCMA').then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
  };

  return service;
}]).factory('AdminApiHelperService', ['$q', 'UtilService', 'HelperService', 'AuthForwarder', '$state', '$stateParams', function ($q, utils, helpers, AuthForwarder, $state, $stateParams) {

  return {
    handleResponse: function handleResponse(response) {
      if (utils.isValidResponse(response)) return response.data;else return $q.reject(helpers.parseAPIError(response));
    },

    handleError: function handleError(response) {
      if (!response || !response.status) return $q.reject('An error has occurred getting the data.');

      if (response.status === 401) {
        AuthForwarder.setForwardState($state.current.name, $stateParams);
        $state.go('login');
      }

      return $q.reject(helpers.parseAPIError(response));
    }
  };
}]);

function BaseAPIFactory(endpoint, API_VARS, $http, $q, helpers, apiHelpers) {

  if (!endpoint) throw 'An endpoint name is required';

  this.endpoint = endpoint;

  return {
    add: function add(args) {
      if (!args) return $q.reject('Add arguments are required.');

      return $http.post(API_VARS.path + '/' + endpoint, args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    count: function count(args) {
      args = args || {};

      return $http.get(API_VARS.path + '/' + endpoint + '/count', { params: args }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    findOne: function findOne(args) {
      if (!args) return $q.reject('Search parameters are required.');

      return $http.get(API_VARS.path + '/' + endpoint + '/findOne', { params: args }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    getAll: function getAll(args) {
      var args = args || {};

      return $http.get(API_VARS.path + '/' + endpoint, { params: args }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    getOne: function getOne(id, args) {
      var args = args || {};

      if (!id) return $q.reject('ID is required.');

      return $http.get(API_VARS.path + '/' + endpoint + '/' + id, { params: args }).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    remove: function remove(id) {
      if (!id) return $q.reject('No ID passed in');

      return $http.delete(API_VARS.path + '/' + endpoint + '/' + id).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    },

    save: function save(args, id) {
      var args = args || {};

      if (!id) return $q.reject('ID is required.');

      return $http.put(API_VARS.path + '/' + endpoint + '/' + id, args).then(apiHelpers.handleResponse).catch(apiHelpers.handleError);
    }
  };
}

angular.module('admin').controller('AdminsCtrl', ['AccountService', '$state', 'FEATURES', function (AccountService, $state, FEATURES) {

  if (!AccountService.hasFeature(FEATURES.ADMIN)) $state.go('login');
}]);

angular.module('admin').controller('AgentClientListCtrl', ['$scope', '$state', '$rootScope', 'HomeService', 'AgentService', 'UtilService', 'APP_CONFIG', '$window', function ($scope, $state, $rootScope, HomeService, AgentService, utils, APP_CONFIG, $window) {

  $scope.agentId = $state.params.id;
  $scope.searchType = 'homeownerName';
  $scope.clientsPerPage = parseInt(APP_CONFIG.CLIENTS_PER_PAGE, 10);
  $scope.homeCount = 0;

  $scope.allClientsSort = $window.localStorage.getItem('hb-client-sort') || 'Name';
  $scope.allClientsOrder = $window.localStorage.getItem('hb-client-order') || 'DESC';

  $scope.getListType = function () {
    if ($state.is('agent.clients') || $state.is('agent.clients.page')) return 'search';

    if ($state.is('agent.clients.needsCMA')) return 'needsCMA';

    if ($state.is('agent.clients.emailIssues')) return 'emailIssues';

    if ($state.is('agent.clients.invited')) return 'invited';

    if ($state.is('agent.clients.sharedClients')) return 'sharedClients';
  };

  $scope.getHomeCount = function () {
    AgentService.countHomes($scope.agentId).then(function (data) {
      $scope.homeCount = data.count;
    });
  };

  $scope.getHomeProcessingCount = function () {
    AgentService.countHomes($scope.agentId, {
      processed: false
    }).then(function (data) {
      $scope.homeProcessingCount = data.count;
    });
  };

  $scope.clearSearch = function () {
    $scope.searchQuery = '';
  };

  $scope.getNeedsCMACount = function () {
    AgentService.countHomes($scope.agentId, {
      'metadata.needsCMA': true
    }).then(function (data) {
      $scope.needsCMACount = data.count;
    });
  };

  $scope.getAgent = function () {
    return AgentService.getOne($scope.agentId).then(function (agent) {
      $scope.agent = agent;
    }).catch(function (err) {
      $scope.error = 'There was an error loading agent profile: ' + err;
    });
  };

  $scope.sendAll = function () {
    if (!confirm('Send an email and text to ' + $scope.unsentCount + ' clients?')) return false;

    $scope.sendingAll = true;
    $scope.error = '';

    AgentService.sendAll($scope.agentId).then(function (data) {
      $scope.sendingAll = false;
    }).catch(function (err) {
      $scope.sendingAll = false;
      $scope.error = err;
      utils.trackException('Send All Digests', err);
    });
  };

  $scope.isView = function (view) {
    return $state.is(view);
  };

  $scope.displayPagination = function () {
    if ($scope.homeCount < $scope.clientsPerPage) return false;

    // TODO: we won't need these when we have search and needsCMA counts
    // The api needs to return the total number of results.
    if ($scope.searchQuery) return false;
    if (!$scope.isView('agent.clients') && !$scope.isView('agent.clients.page')) return false;

    return true;
  };

  $scope.isUserList = function () {
    var userListTypes = ['emailIssues', 'invited'];
    if (userListTypes.includes($scope.getListType())) return true;

    return false;
  };

  var pageWatch = $rootScope.$on('$stateChangeStart', setCurrentPage);

  $scope.$on('$destroy', pageWatch); // removes from $rootScope

  function setCurrentPage(evt, toState, toParams) {
    $scope.currentPage = toParams.page && toParams.page > 0 ? toParams.page : 1;
  };

  function setSort(sort) {
    $scope.allClientsSort = sort;
    $window.localStorage.setItem('hb-client-sort', $scope.allClientsSort);
  }

  function setSortOrder(isNewSort) {
    if (isNewSort || $scope.allClientsOrder === 'ASC') $scope.allClientsOrder = 'DESC';else $scope.allClientsOrder = 'ASC';

    $window.localStorage.setItem('hb-client-order', $scope.allClientsOrder);
  }

  $scope.updateSort = function (sort) {
    var isNewSort = sort === $scope.allClientsSort ? false : true;
    setSort(sort);
    setSortOrder(isNewSort);
    setCurrentPage(null, null, { page: 1 });
    $state.go('agent.clients');
  };

  $scope.goToPage = function (text, page) {
    $state.go('agent.clients.page', { page: page });
    window.scrollTo(0, 0);
  };

  setCurrentPage(null, null, $state.params);
  $scope.getAgent();
  $scope.getHomeCount();
  $scope.getHomeProcessingCount();
  $scope.getNeedsCMACount();
}]);

angular.module('admin').controller('AgentBillingCtrl', ['$scope', '$state', 'AgentService', 'PageNotificationService', function ($scope, $state, AgentService, PageNotificationService) {

  $scope.agentId = $state.params.id;

  $scope.getAgent = function () {
    return AgentService.getOne($scope.agentId).then(function (agent) {
      $scope.agent = agent;
    }).catch(function (err) {
      PageNotificationService.error('There was an error loading agent profile: ' + err);
    });
  };

  $scope.showBillingModal = function () {
    $scope.currentModal = 'billing';
  };

  $scope.hideModal = function () {
    $scope.currentModal = null;
    $scope.getAgent();
  };

  $scope.getAgent();
}]);

angular.module('admin').controller('AgentHomeDetailCtrl', ['$scope', '$state', 'UserService', 'HomeActivity', 'HomeService', 'AccountService', 'AgentService', 'Dictionary', 'ActivityDictionary', '$q', 'HelperService', 'UtilService', '$timeout', 'PageNotificationService', 'FEATURES', function ($scope, $state, UserService, HomeActivity, HomeService, AccountService, AgentService, Dictionary, ActivityDictionary, $q, helpers, utils, $timeout, PageNotificationService, FEATURES) {

  $scope.accountService = AccountService;
  $scope.currentModal = false;
  $scope.newUser = {};
  $scope.testDigestEmail = AccountService.getAgent('email');
  $scope.loading = true;
  $scope.refreshingUsers = false;
  $scope.emailTipOpen = false;
  $scope.showV2Digest = false;
  $scope.answers = [];

  var dictionary = new Dictionary();
  var activityDictionary = new ActivityDictionary();
  var homeId = $state.params.homeId;
  var agentId = $state.params.id;
  var clientId = $state.params.clientId;
  var usersRefreshCount = 0;

  $scope.refreshHomeActivity = function () {
    if (!$scope.home.users && $scope.home.users.length) return;
    _.each($scope.home.users, function (user, i) {
      user.loading = true;
      user.activity = [];
      HomeActivity.getUserHomeActivity(user.id, homeId).then(function success(data) {
        user.loading = false;
        user.activity = data;
        user.isActive = _.filter(user.activity, helpers.isActiveFilter).length;
        $scope.combineStreams();
      }, function error(err) {
        utils.trackException('Admin Refresh Home Activity', err);
      });
    });
  };

  $scope.setCurrentAgent = function () {
    return AgentService.getOne(agentId).then(function (agent) {
      $scope.agent = agent;
      $scope.showV2Digest = _.contains(agent.features, FEATURES.DIGEST_V2);
      $scope.hasMortgageCoach = _.contains(agent.features, FEATURES.MORTGAGE_COACH);
    }).catch(function (e) {
      $scope.error = 'There was an error loading your agent profile.';
    });
  };

  $scope.sendRealDigest = function (user) {
    if (user) var users = [user];else var users = $scope.home.users;

    var names = _.pluck(users, 'first_name');
    var args = {
      users: _.pluck(users, 'id')
    };

    if (!args.users) return;

    if (!confirm('Send an email to ' + names.join(' and ') + '?')) return;

    $scope.sending = true;

    HomeService.sendDigest($scope.home.id, args).then(function () {
      $scope.refreshHomeActivity();
      $scope.home.emailOpen = false;
      $scope.sending = false;
      $scope.needsCMANotification = false;
    }).catch(function (err) {
      $scope.sending = false;
      $scope.refreshHomeActivity();
      alert('There was an error sending the digest(s):' + err);
    });
  };

  $scope.sendTestDigest = function () {
    var email = $scope.testDigestEmail;

    if (!email) return;

    $scope.sendingTest = true;

    HomeService.sendDigestTest($scope.home.id, email).then(function () {
      $scope.home.emailOpen = false;
      $scope.sendingTest = false;
    }).catch(function (err) {
      $scope.sendingTest = false;
      alert('There was an error sending the email(s): ' + err);
    });
  };

  $scope.sendCMANotification = function (user) {
    $scope.sendingCMANotification = true;

    HomeActivity.trackHome({ 'source': 'agent', 'event': 'cma-notify-client', 'userId': $scope.home.users[0].id, 'homeId': homeId, 'agentId': agentId }).then(function nextUser(data) {
      if ($scope.home.users.length > 1) return HomeActivity.trackHome({ 'source': 'agent', 'event': 'cma-notify-client', 'userId': $scope.home.users[1].id, 'homeId': homeId, 'agentId': agentId });else return data;
    }).then(function success(data) {
      $scope.refreshHomeActivity();
      $scope.sendingCMANotification = false;
      $scope.needsCMANotification = false;
    }, function error(err) {
      $scope.refreshHomeActivity();
      $scope.sendingCMANotification = false;
      utils.trackException('Admin Send CMA Notification', err);
      console.log(err);
    });
  };

  $scope.refreshHome = function () {
    $q.all([HomeService.getAnswers(homeId), HomeService.getDetailedHome(homeId)]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          answersResult = _ref2[0],
          detailedResult = _ref2[1];

      $scope.setLastUpdatedHomeFacts(answersResult);
      return detailedResult;
    }).then(function (home) {
      $scope.home = home;
      $scope.home.users = helpers.sortUsers($scope.home.users);
      $scope.refreshHomeActivity();
      $scope.setupCMA();
      $scope.cmaOpen = false;
      $scope.setUserTab(clientId);
      $scope.loading = false;
      $scope.setEmailValidationTimeout();
    }).catch(function (data) {
      $scope.loading = false;
      $scope.error = 'There was an error loading this home.';
    });
  };

  $scope.refreshUsers = function () {
    $scope.refreshingUsers = true;
    usersRefreshCount++;

    HomeService.getUsers(homeId).then(function (users) {
      $scope.home.users = helpers.sortUsers(_.flatten(users));
      $scope.refreshingUsers = false;
      $scope.setEmailValidationTimeout();
    }).catch(function (data) {
      $scope.error = 'There was an error loading these homeowners.';
    });
  };

  $scope.hasEmailsValidating = function () {
    return _.some($scope.home.users, { emailVerificationUpdatedAt: null });
  };

  $scope.setEmailValidationTimeout = function () {
    if (!$scope.hasEmailsValidating() || usersRefreshCount > 2) return;

    $timeout(function () {
      if ($scope.currentModal || $scope.editUserNote) return;

      $scope.refreshUsers();
    }, 8000);
  };

  $scope.setLastUpdatedHomeFacts = function (answers) {
    $scope.answers = answers;
    if (_.isEmpty(answers)) {
      $scope.bedsBathsUpdated = undefined;
      $scope.saleFactsUpdated = undefined;
    } else {
      (function () {
        var physicalFacts = ['fact:bedrooms', 'fact:bathrooms', 'fact:finishedSqFt'];
        var saleFacts = ['fact:soldDate', 'fact:soldPrice'];
        var sortedAnswers = _.sortByOrder(answers, 'updated', 'desc');
        $scope.bedsBathsUpdated = _.result(_.find(sortedAnswers, function (answer) {
          return physicalFacts.includes(answer.question);
        }), 'updated');
        $scope.saleFactsUpdated = _.result(_.find(sortedAnswers, function (answer) {
          return saleFacts.includes(answer.question);
        }), 'updated');
      })();
    }
  };

  $scope.saveHome = function () {
    var args = { address: { street: $scope.home.address.street, unit: $scope.home.address.unit, zip: $scope.home.address.zip } };
    $scope.formError = '';

    HomeService.save(args, homeId).then(function success(home) {
      $scope.set('currentModal', false);
      $scope.refreshHome();
    }, function error(err) {
      $scope.formError = err;
      utils.trackException('Admin Update Address', err);
    });
  };

  $scope.deleteHome = function (home, usersExistOnHome) {
    var homeAddress = home.address.street;
    var message = 'Are you sure you want to remove ' + homeAddress + '?';

    if (usersExistOnHome) message += ' If this client is linked to other properties, the client will NOT be removed.';

    if (!confirm(message)) return;

    $scope.deletingHome = true;

    HomeService.remove(home.id).then(function success() {
      $scope.deletingHome = false;
      $state.go('agent.clients', { id: agentId });
      PageNotificationService.success(homeAddress + ' has been successfully deleted.');
    }, function error(err) {
      $scope.deletingHome = false;
      alert('Error:', err);
      utils.trackException('Admin Remove Home', err);
    });
  };

  $scope.closeEditModal = function () {
    $scope.set('currentModal', false);
    $scope.refreshHome();
  };

  $scope.onUserDelete = function () {
    $scope.closeEditModal();
    $scope.clientTabId = null;
  };

  $scope.setupCMA = function () {
    if ($scope.lookup('cmaBuyersAgentPreferred')) $scope.preferredRea = $scope.home.sellingAgent;

    // TODO: we need a cma request model for this
    HomeActivity.getCmaRequest($scope.home.id).then(function (activityItems) {
      var requesterId = activityItems.length ? activityItems[0].userId : null;
      var users = _.filter($scope.home.users, function (user) {
        return user.id === requesterId;
      });
      $scope.cmaRequester = users.length ? users[0] : $scope.home.users[0];
    });
  };

  $scope.setUserTab = function (id) {
    if ($scope.home.users && $scope.home.users.length) $scope.clientTabId = id || $scope.clientTabId || $scope.home.users[0].id;
  };

  $scope.lookup = function (prop, args) {
    return dictionary[prop]($scope.home, args);
  };

  $scope.combineStreams = function () {
    var stream = [];
    _.each($scope.home.users, function (user) {
      stream = stream.concat(user.activity);
    });
    return $scope.combinedStream = stream;
  };

  $scope.updateExternalData = function () {
    $scope.updatingHomeData = true;

    HomeService.updateExternalData(homeId).then(function () {
      $scope.updatingHomeData = false;
      $scope.refreshHome();
    }).catch(function (err) {
      $scope.updatingHomeData = false;
      alert('Error updating home' + err);
    });
  };

  $scope.recompileHome = function () {
    $scope.recompilingHome = true;

    HomeService.recompileHome(homeId).then(function () {
      $scope.recompilingHome = false;
      $scope.refreshHome();
    }).catch(function (err) {
      $scope.recompilingHome = false;
      alert('Error recompiling home' + err);
    });
  };

  $scope.deleteLoans = function () {
    if (!confirm('Delete loans?')) return false;

    $scope.deletingLoans = true;

    HomeService.deleteLoans(homeId).then(function () {
      $scope.deletingLoans = false;
      $scope.refreshHome();
    }).catch(function (err) {
      $scope.deletingLoans = false;
      alert('Error deleting loans' + err);
    });
  };

  $scope.resetCMA = function () {
    if (!confirm('Reset CMA: this will delete the CMA and all answers given by the client. Do it?')) return false;

    $scope.resettingCMA = true;

    HomeService.resetCMA(homeId).then(function (home) {
      $scope.resettingCMA = false;
      $scope.refreshHome();
    }).catch(function (err) {
      $scope.resettingCMA = false;
      alert('Error:', err);
      utils.trackException('Admin Reset CMA', err);
    });
  };

  $scope.showCMA = function () {
    $scope.currentModal = 'cmaEntry';
  };

  $scope.hasSellingAgent = function () {
    try {
      return $scope.home.sellingAgent.datasources.rets.status === 'success';
    } catch (e) {
      return false;
    };
  };

  $scope.lookupActivity = function (prop, stream) {
    stream = stream || $scope.combinedStream;
    return activityDictionary[prop](stream);
  };

  $scope.set = function (prop, val) {
    $scope[prop] = val;
  };

  $scope.toggleProp = function (prop, scope, val) {
    scope = scope || $scope;
    val = val || !scope[prop];

    scope[prop] = val;
  };

  $scope.updateUserNote = function (user) {
    var args = {
      agent_note: user.agent_note
    };
    $scope.formError = '';

    UserService.save(args, user.id).then(function () {
      $scope.editUserNote = false;
    }).catch(function (err) {
      $scope.formError = err;
      utils.trackException('Admin Update User Note', err);
    });
  };

  $scope.removeUserNote = function (user) {
    user.agent_note = "";
    var args = {
      agent_note: user.agent_note
    };
    $scope.formError = '';
    $scope.editUserNote = false;

    UserService.save(args, user.id).catch(function (err) {
      $scope.formError = err;
      utils.trackException('Admin Update User Note', err);
    });
  };

  $scope.showEquityHomePreview = function () {
    if (!$scope.home) return false;

    if ($scope.showV2Digest || !$scope.agent) return false;

    var maximumLTV = 0.8;
    var minimumEquity = 25000;

    var fiveMonthsAgo = moment().subtract(5, 'months');
    var currentLoans = dictionary.currentLoansNoHelocs($scope.home);

    var hasLoanNewerThanFiveMonths = _.any(currentLoans, function (loan) {
      return moment(loan.date).isAfter(fiveMonthsAgo);
    });

    if (hasLoanNewerThanFiveMonths) return false;

    var outstandingPrincipal = _.sum(currentLoans, function (loan) {
      return _.get(loan, 'progress.principal_left', 0);
    });

    var currentAvm = _.get($scope.home, 'metadata.homeValue');
    var leverageableEquity = currentAvm * maximumLTV - outstandingPrincipal;

    return leverageableEquity > minimumEquity;
  };

  $scope.hasLoansForRefi = function () {
    if (!$scope.home || !$scope.agent) return false;

    var currentLoans = dictionary.currentLoansNoHelocs($scope.home);

    return currentLoans.length > 0;
  };

  $scope.hasLoanPastFiveMonthsForRefi = function () {
    if (!$scope.home || !$scope.agent) return false;

    var fiveMonthsAgo = moment().subtract(5, 'months');
    var currentLoans = dictionary.currentLoansNoHelocs($scope.home);

    var hasLoanNewerThanFiveMonths = _.any(currentLoans, function (loan) {
      return moment(loan.date).isAfter(fiveMonthsAgo);
    });

    return !hasLoanNewerThanFiveMonths;
  };

  $scope.digestScheduledAtRange = function (user) {
    var digestScheduledAt = user.digestScheduledAt;
    var startDate = moment(digestScheduledAt).format('M/DD');
    var endDate = moment(digestScheduledAt).add(10, 'days').format('M/DD');

    return startDate + ' - ' + endDate;
  };

  $scope.refreshHome();
  $scope.setCurrentAgent();
}]);

angular.module('admin').controller('AgentImportClientsCtrl', ['$scope', '$state', 'UserService', 'HomeService', '$timeout', 'UtilService', 'HelperService', function ($scope, $state, UserService, HomeService, $timeout, utils, helpers) {

  $scope.agentId = $state.params.id;

  var parser = new HBParser('encompass');

  $scope.parseFile = function (e) {
    $scope.$apply(function () {
      $scope.loading = true;
    });

    var csv;

    if (e && e.target && e.target.files) csv = e.target.files[0];

    if (!csv) throw 'Error reading file';

    Papa.parse(csv, {
      header: true,
      skipEmptyLines: true,
      complete: function complete(results) {

        var clients = parser.parse(results.data);
        clients = $scope.compactData(clients);

        $scope.$apply(function () {
          $scope.clients = clients;
          $scope.loading = false;
        }, 800);
      }
    });
  };

  $scope.uploadClients = function () {
    var args = {
      clients: $scope.clients,
      agentId: $scope.agentId
    };

    $scope.loading = true;

    HomeService.createManyHomes(args).then(function (data) {
      console.log(data);
      $scope.loading = false;
      $scope.clients = false;
      $scope.uploadResults = data;
    }).catch(function (e) {
      console.log('Error', e);
    });
  };

  $scope.compactData = function (clients) {
    return _.map(clients, function (row) {
      var ret = {
        users: [],
        loans: []
      };

      var home = _.pick(row.home, _.identity);
      var user1 = _.pick(row.user, _.identity);
      var user2 = _.pick(row.user2, _.identity);
      var loan = _.pick(row.loan, _.identity);

      ret.home = home;

      if (user1 && !_.isEmpty(user1)) ret.users.push(user1);

      if (user2 && !_.isEmpty(user2)) ret.users.push(user2);

      if (loan && !_.isEmpty(loan)) {
        loan.source = 'lender';
        ret.loans.push(loan);
      }

      return ret;
    });
  };

  function groupErrors(failures) {
    return _.groupBy(failures, function (failure) {
      return failure.error.code;
    });
  };

  $scope.closeModal = function () {
    $scope.currentModal = null;
  };
}]);

angular.module('admin').controller('AgentNavCtrl', ['$scope', '$state', 'AgentService', 'AccountService', 'UtilService', function ($scope, $state, AgentService, AccountService, utils) {

  $scope.getId = function () {
    return $state.params.id;
  };

  $scope.showFullClientsNav = function () {
    return !$state.is('agent.edit') && !$state.is('agent.billing') && !$state.is('agent.share');
  };

  $scope.pageTitle = function () {
    if ($state.current.data && $state.current.data.pageTitle) return $state.current.data.pageTitle;else return $scope.getNamePossesive() + ' Clients';
  };

  $scope.backurl = function () {
    if ($state.current.data && $state.current.data.back) return $state.href($state.current.data.back, { id: $scope.getId() });else return false;
  };

  $scope.getAgent = function () {
    AgentService.getOne($scope.getId()).then(function success(data) {
      $scope.agent = data;
    }, function error(err) {
      utils.trackException('Admin AgentCtrl Get Agent', err);
    });
  };

  $scope.getName = function () {
    if (!$scope.agent) return '';

    if ($scope.getId() === AccountService.getAgentId()) return "You";else return $scope.agent.first_name + ' ' + $scope.agent.last_name;
  };

  $scope.getNamePossesive = function () {
    if (!$scope.agent) return '';

    if ($scope.getId() === AccountService.getAgentId()) return "Your";else return $scope.agent.first_name + ' ' + $scope.agent.last_name + '\'s';
  };

  $scope.getAgent();
}]);

angular.module('admin').controller('AgentNewClientCtrl', ['$scope', '$state', 'HomeService', 'UtilService', 'ScrollService', 'HelperService', 'AgentService', 'FEATURES', function ($scope, $state, HomeService, utils, ScrollService, helpers, AgentService, FEATURES) {
  $scope.agentId = $state.params.id;

  $scope.savedHome = {};

  $scope.reset = function () {
    $scope.newUser1 = { borrowerType: 'borrower' };
    $scope.newUser2 = { borrowerType: 'coborrower' };
    $scope.newHome = {};
  };

  $scope.addHomeAndUsers = function () {
    $scope.loading = true;
    $scope.newHomeAndUserError = '';
    $scope.addingHomeAndUserSuccess = false;

    var error = function error(err) {
      $scope.newHomeAndUserError = Array.isArray(err) ? err[0] : err;
      utils.trackException('Add Home and User', err);
      $scope.loading = false;
    };

    if ($scope.newUser1.mobile) $scope.newUser1.mobile = helpers.formatPhone($scope.newUser1.mobile);

    if ($scope.newUser2.mobile) $scope.newUser2.mobile = helpers.formatPhone($scope.newUser2.mobile);

    var client = {
      home: $scope.newHome,
      users: [$scope.newUser1]
    };

    if ($scope.newUser2.email) client.users.push($scope.newUser2);

    HomeService.createHome({ client: client, agentId: $scope.agentId }).then(function (home) {
      $scope.savedHome = home;
      $scope.loading = false;
      $scope.addingHomeAndUserSuccess = true;
      $scope.reset();
      ScrollService.scroll({ target: 'addClientTop' });
    }).catch(error);
  };

  $scope.setShowV2Digest = function () {
    return AgentService.getOne($scope.agentId).then(function (agent) {
      $scope.showV2Digest = _.contains(agent.features, FEATURES.DIGEST_V2);
    }).catch(function (e) {
      $scope.showV2Digest = false;
    });
  };

  $scope.reset();
  $scope.setShowV2Digest();
}]);

angular.module('admin').controller('AgentRealEstateAgentsCtrl', ['$scope', '$state', '$rootScope', 'AgentService', function ($scope, $state, $rootScope, AgentService) {

  $scope.agentId = $state.params.id;

  $scope.state = $state;

  $scope.currentMlsPro = null;
  $scope.currentSponsoredAgent = null;

  var reAgentWatch = $rootScope.$on('$stateChangeSuccess', updateCurrentAgent);

  $scope.$on('$destroy', reAgentWatch); // removes from $rootScope

  function getAgent() {
    AgentService.getOne($scope.agentId).then(function (result) {
      $scope.agent = result;
    }).catch(onError);
  }

  function getMlsPro(mlsset) {
    AgentService.realEstateAgents($scope.agentId, mlsset).then(function (result) {
      $scope.currentMlsPro = result;
    }).catch(onError);
  }

  function getSponsoredAgent(sponsoredAgentId) {
    AgentService.getSponsoredAgent($scope.agentId, sponsoredAgentId).then(function (result) {
      $scope.currentSponsoredAgent = result;
    }).catch(onError);
  }

  function updateCurrentAgent(event, toState, toParams) {
    $scope.currentMlsPro = null;
    $scope.currentSponsoredAgent = null;

    if (toParams.mlsset) return getMlsPro(toParams.mlsset);

    if (toParams.sponsoredAgentId) return getSponsoredAgent(toParams.sponsoredAgentId);
  }

  function onError(e) {
    $scope.error = e;
  }

  function init() {
    if ($state.params.mlsset) getMlsPro($state.params.mlsset);

    if ($state.params.sponsoredAgentId) getSponsoredAgent($state.params.sponsoredAgentId);

    getAgent();
  }

  init();
}]);

angular.module('admin').controller('AgentSponsorsCtrl', ['$scope', '$state', 'AgentService', 'PageNotificationService', function ($scope, $state, AgentService, PageNotificationService) {

  $scope.agentId = $state.params.id;

  function getAgent() {
    return AgentService.getOne($scope.agentId).then(function (agent) {
      $scope.agent = agent;
    });
  };

  function getSponsor() {
    if (!$scope.agent.sponsor_id) return;

    return AgentService.getSponsor($scope.agentId).then(function (sponsor) {
      if (!_.isEmpty(sponsor)) $scope.sponsor = sponsor;
    });
  };

  $scope.refresh = function () {
    $scope.loading = true;

    return getAgent().then(getSponsor).then(function () {
      $scope.loading = false;
    }).catch(function (err) {
      $scope.loading = false;
      $scope.error = 'There was an error loading your sponsors: ' + err;
    });
  };

  $scope.refresh();
}]);

angular.module('admin').controller('AgentStreamCtrl', ['$scope', '$state', '$interval', 'HomeActivity', 'UtilService', 'ActivityDictionary', function ($scope, $state, $interval, HomeActivity, utils, ActivityDictionary) {

  $scope.agentId = $state.params.id;

  $scope.startDate = moment().subtract(30, 'days').startOf('day').toDate();
}]);

angular.module('admin').controller('AgentCtrl', ['$scope', '$state', 'AgentService', 'PageNotificationService', function ($scope, $state, AgentService, PageNotificationService) {

  $scope.agentId = $state.params.id;

  $scope.getAgent = function () {
    return AgentService.getOne($scope.agentId, { filter: { include: ['office'] } }).then(function (agent) {
      $scope.agent = agent;
    }).catch(function (err) {
      PageNotificationService.error('There was an error loading agent profile. ' + err);
    });
  };

  $scope.getAgent();
}]);

angular.module('admin').controller('AgentsCtrl', ['$scope', '$state', 'AgentService', 'UserService', 'OfficeService', 'AccountService', 'HelperService', function ($scope, $state, AgentService, UserService, OfficeService, AccountService, helpers) {

  $scope.officeId = $state.params.officeId;
  $scope.accountService = AccountService;

  $scope.agentFilter = function (row) {
    var regexQuery = new RegExp($scope.query, 'i');
    return !$scope.query || regexQuery.test(row.first_name) || regexQuery.test(row.last_name) || regexQuery.test(row.email) || regexQuery.test(row.nmls);
  };

  $scope.getAllAgents = function () {
    var params = void 0;

    if ($scope.officeId) {
      params = { filter: { where: { 'officeId': $scope.officeId } } };
    } else if ($state.is('admins.agentBKSearch')) {
      params = { filter: { where: { 'source': 'bkfs' } } };
    } else {
      params = {};
    }

    $scope.loading = true;

    AgentService.getAll(params).then(function (data) {
      $scope.agents = data;
      $scope.loading = false;
    }).catch(function (err) {
      $scope.error = err;
      $scope.loading = false;
    });
  };

  $scope.refreshData = function () {
    $scope.getAllAgents();
  };

  $scope.hasAgents = function () {
    return $scope.agents.length > 0;
  };

  $scope.refreshData();
}]);

angular.module('admin').controller('LoggedInUserCtrl', ['$q', '$scope', 'AccountService', 'SessionService', 'AgentService', 'AuthResolver', 'SSOService', function ($q, $scope, AccountService, SessionService, AgentService, AuthResolver, SSOService) {

  $scope.accountService = AccountService;
  $scope.SessionService = SessionService;

  $scope.groups = [];

  $scope.retrieveGroups = function () {
    var jwt = SessionService.extractJWT();

    if (_.get(jwt, 'acr.values[0]')) {
      (function () {
        var groupPromises = [];
        var values = jwt.acr.values;
        var agentId = AccountService.getAgent('id');

        values.forEach(function (value) {
          if (!value.context) return;

          var _value$context$split = value.context.split(':'),
              _value$context$split2 = _slicedToArray(_value$context$split, 2),
              type = _value$context$split2[0],
              _id = _value$context$split2[1];

          if (type === 'company') {
            groupPromises.push(AgentService.getBrokerage(agentId));
          }
        });

        $q.all(groupPromises).then(function (groups) {
          $scope.groups = groups;
        });
      })();
    }
  };

  $scope.showTrialBanner = false;

  $scope.checkTrialStatus = function () {
    if (AccountService.getAgent('hasCosponsorship')) {
      return $scope.showTrialBanner = false;
    }

    return $scope.showTrialBanner = false;
    // TODO: Figure out way to get this subscription info from the customer
    // let planCode
    // let planStartedAt
    // if (planCode && planStartedAt) {
    //   const isBabAgent = planCode === 'bab-agent-starter';
    //   const trialStartDate = planStartedAt;
    //   const daysSinceTrialStartDate = moment().utc().diff(trialStartDate, 'days');
    //   const daysInTrial = isBabAgent ? 90 : 30
    // 
    //   $scope.isBabAgent = isBabAgent;
    //   $scope.showTrialBanner = true;
    //   $scope.trialDaysLeft = Math.max(0, daysInTrial - daysSinceTrialStartDate);
    // }
  };

  $scope.init = function () {
    AuthResolver.identifyUser().then(function () {
      $scope.retrieveGroups();
      $scope.checkTrialStatus();
    });
  };

  $scope.init();
}]);

angular.module('admin').controller('OfficeNavCtrl', ['$scope', '$state', 'AccountService', 'FEATURES', function ($scope, $state, AccountService, FEATURES) {

  $scope.accountService = AccountService;

  $scope.getId = function () {
    return $state.params.id;
  };

  $scope.pageTitle = function () {
    if ($state.current.data && $state.current.data.pageTitle) return $state.current.data.pageTitle;else if ($scope.accountService.hasFeature(FEATURES.ADMIN)) return 'Companies';else return 'Your Offices';
  };

  $scope.backurl = function () {
    if ($state.current.data && $state.current.data.back) return $state.href($state.current.data.back, { id: $scope.getId() });else return false;
  };
}]);

angular.module('admin').controller('OfficesStreamCtrl', ['$scope', '$state', 'AgentService', 'HomeActivity', 'AccountService', 'HelperService', 'UtilService', function ($scope, $state, AgentService, HomeActivity, AccountService, helpers, utils) {

  $scope.accountService = AccountService;

  $scope.getAllAgents = function () {
    var params = {};

    AgentService.getAll(params).then(function success(agents) {
      $scope.agents = agents;
      $scope.getActivity();
    }, function error(err) {
      utils.trackException('Get all offices error', err);
    });
  };

  $scope.getActivity = function () {
    var params = { filter: { include: ['agent', 'user'], where: { 'agentId': { inq: _.pluck($scope.agents, 'id') } } } };

    HomeActivity.getAll(params).then(function success(activity) {
      $scope.allActivity = activity;
    }, function error(err) {
      utils.trackException('Get all offices error', err);
    });
  };

  $scope.getAllAgents();
}]);

angular.module('admin').controller('OfficesCtrl', ['$scope', '$state', 'OfficeService', 'BrokerageService', 'AccountService', 'HelperService', 'UtilService', 'FEATURES', function ($scope, $state, OfficeService, BrokerageService, AccountService, helpers, utils, FEATURES) {

  $scope.accountService = AccountService;

  var params = {};

  if ($scope.accountService.hasFeature(FEATURES.ADMIN)) params = { filter: { include: 'offices', order: 'name ASC' } };

  $scope.refreshBrokerages = function () {
    BrokerageService.getAll(params).then(function (data) {
      $scope.brokerages = data;
    }).catch(function (err) {
      utils.trackException('Get all offices error', err);
    });
  };

  $scope.showAddOffice = function (brokerage) {
    $scope.addOfficeBrokerage = brokerage;
    $scope.currentModal = 'addOffice';
  };

  $scope.showEditOffice = function (office) {
    $scope.editOffice = office;
    $scope.currentModal = 'editOffice';
  };

  $scope.showEditBrokerage = function (brokerage) {
    $scope.editBrokerage = brokerage;
    $scope.currentModal = 'editBrokerage';
  };

  $scope.closeModal = function () {
    $scope.currentModal = false;
    $scope.editBrokerage = null;
    $scope.editOffice = null;
    $scope.refreshBrokerages();
  };

  $scope.refreshBrokerages();
}]);

angular.module('admin').controller('StartCtrl', ['$scope', '$state', 'AccountService', 'AuthForwarder', 'SessionService', 'AuthResolver', 'FEATURES', function ($scope, $state, AccountService, AuthForwarder, SessionService, AuthResolver, FEATURES) {

  $scope.accountService = AccountService;

  $scope.setGARole = function () {
    if ($scope.accountService.hasFeature(FEATURES.ADMIN)) {
      ga('set', 'dimension1', 'admin');
    } else {
      ga('set', 'dimension1', 'agent');
    }
  };

  $scope.startUser = function () {
    $scope.setGARole();
    $scope.accountService.initIntercom();
    AuthForwarder.forwardAfterLogin();
  };

  var jwtPayload = SessionService.extractJWT();

  if (jwtPayload) {
    AuthResolver.identifyUser().then(function (user) {
      $scope.startUser();
    }).catch(function (err) {
      $state.go('login');
    });
  } else if (SessionService.isLoggedIn()) {
    // Support users with old login (remove at some point)
    $scope.startUser();
  } else {
    $state.go('login');
  }
}]);

angular.module('admin.directives').directive('addBrokerage', addBrokerage);

function addBrokerage() {

  return {
    bindToController: {
      onSaved: '&',
      onCancel: '&'
    },
    controller: addBrokerageCtrl,
    controllerAs: 'ctrl',
    templateUrl: '/admin/templates/add-edit-brokerage.html',
    restrict: 'E',
    scope: {}
  };
};

addBrokerageCtrl.$inject = ['BrokerageService', 'HelperService'];

function addBrokerageCtrl(Service, helpers) {
  var ctrl = this;

  ctrl.subject = {};
  ctrl.subject.showAddress = true;
  ctrl.subject.showNightlyRentals = true;
  ctrl.subject.showReverseMortgage = true;

  return _.merge(ctrl, {
    submit: add
  });

  /////

  function onSave() {
    ctrl.loading = false;

    if (ctrl.onSaved) ctrl.onSaved();
  };

  function onError(errorMsg) {
    ctrl.formError = errorMsg;
    ctrl.loading = false;
  };

  function parseForSave(subject) {
    subject = _.cloneDeep(subject);
    subject.phone = helpers.formatPhone(subject.phone);
    return subject;
  };

  function add() {
    ctrl.loading = true;
    var subject = parseForSave(ctrl.subject);

    Service.add(subject).then(onSave).catch(onError);
  };
};

angular.module('admin.directives').directive('addEditBillingInfo', ['RecurlyTokenService', '$timeout', 'AgentService', 'ScrollService', 'UtilService', function (RecurlyTokenService, $timeout, AgentService, ScrollService, utils) {

  return {
    restrict: 'E',
    controllerAs: 'addEditBillingInfoCtrl',
    bindToController: {
      agent: '=',
      onCancel: '&',
      onSave: '&'
    },
    scope: {},
    templateUrl: '/admin/templates/partials/add-edit-billing-info.html',

    controller: function controller() {
      var ctrl = this;

      ctrl.submit = function () {
        ctrl.error = '';
        ctrl.loading = true;
        utils.track('BillingCreditCardSubmit');

        RecurlyTokenService.fetchToken(ctrl.htmlFormElement).then(function (token) {
          return AgentService.createRecurlyAccount(ctrl.agent.id, token);
        }).then(success).catch(error);
      };

      ctrl.cancel = function () {
        ctrl.onCancel();
      };

      function success() {
        ScrollService.scroll({ target: 'billingFormTop' });
        ctrl.loading = false;
        ctrl.onSave();
      }

      function error(e) {
        ScrollService.scroll({ target: 'billingFormTop' });
        ctrl.loading = false;
        ctrl.error = e.message ? e.message : e;
        utils.trackException('Billing Credit Card Submit', ctrl.error);
      }
    },

    link: function link($scope, el, attrs, ctrl) {
      ctrl.htmlFormElement = el[0].querySelector('form');

      $timeout(initRecurly, 0); // ensure html element is ready in dom

      function initRecurly() {
        recurly.configure({
          style: {
            all: {
              fontColor: '#FC5AA6',
              fontFamily: 'Open Sans',
              fontSize: '1.6rem'
            },
            input: {
              borderColor: 'transparent',
              backgroundColor: 'rgba(255,255,255,.05)'
            },
            number: {
              placeholder: ''
            },
            month: {
              placeholder: 'MM'
            },
            year: {
              placeholder: 'YY'
            }
          }
        });

        recurly.on('field:submit', ctrl.submit);
      }
    }
  };
}]);

angular.module('admin.directives').directive('addEditUser', ['UserService', 'HomeService', 'HelperService', 'AgentService', 'FEATURES', function (UserService, HomeService, helpers, AgentService, FEATURES) {
  return {
    restrict: 'E',
    controllerAs: 'addEditUserCtrl',
    bindToController: {
      agentId: '=?',
      homeId: '=?',
      mode: '@',
      onSaved: '&',
      onCancel: '&',
      onDelete: '&',
      showDelete: '=',
      showHomes: '=?',
      showSharedToggle: '=?',
      languageOptionsEnabled: '=?',
      user: '=?'
    },
    scope: {},
    templateUrl: '/admin/templates/partials/add-edit-user.html',

    controller: function controller() {
      var ctrl = this;

      ctrl.submit = function () {
        ctrl.successful = null;
        ctrl.error = null;

        if (ctrl.mode === 'edit') ctrl.save();else ctrl.add();
      };

      ctrl.add = function () {
        var user = parseForSaving(ctrl.user);
        ctrl.saving = true;

        if (!ctrl.homeId) {
          ctrl.error = 'There was an error adding this user.';
          return;
        }

        HomeService.addUserToHome(ctrl.homeId, ctrl.user).then(success).catch(error);
      };

      ctrl.save = function () {
        var user = parseForSaving(ctrl.user);
        ctrl.saving = true;

        UserService.save(user, ctrl.user.id).then(success).catch(error);
      };

      ctrl.deleteUser = function () {
        if (!confirm('Are you sure you want to remove ' + ctrl.user.first_name + ' ' + ctrl.user.last_name + '?')) return;

        ctrl.saving = true;
        ctrl.error = '';

        UserService.remove(ctrl.user.id).then(function () {
          ctrl.successful = true;
          ctrl.error = null;
          ctrl.saving = false;
          ctrl.onDelete();
        }).catch(error);
      };

      function success(user) {
        ctrl.successful = true;
        ctrl.error = null;
        ctrl.saving = false;
        ctrl.resetAdd();
        ctrl.onSaved();
      };

      function error(err) {
        ctrl.error = err;
        ctrl.saving = false;
      };

      function parseForSaving(user) {
        var userForSave = {
          email: user.email,
          first_name: user.first_name,
          last_name: user.last_name,
          mobile: helpers.formatPhone(user.mobile),
          locale: user.locale
        };

        if (ctrl.agentId) userForSave.agentId = ctrl.agentId;

        return userForSave;
      };

      ctrl.resetAdd = function () {
        if (ctrl.mode === 'edit') return;

        ctrl.user = {};
      };

      ctrl.resetAdd();
    }
  };
}]);

angular.module('admin.directives').directive('addOffice', addOffice);

function addOffice() {

  return {
    bindToController: {
      brokerage: '=',
      onCancel: '&',
      onSaved: '&'
    },
    controller: addOfficeCtrl,
    controllerAs: 'ctrl',
    link: link,
    templateUrl: '/admin/templates/add-edit-office.html',
    restrict: 'E',
    scope: {}
  };
};

addOfficeCtrl.$inject = ['OfficeService', 'HelperService'];

function addOfficeCtrl(Service, helpers) {
  var ctrl = this;

  return _.merge(ctrl, {
    setup: setup,
    submit: add
  });

  /////

  function setup() {
    ctrl.subject = {};
  };

  function onSave() {
    ctrl.loading = false;

    if (ctrl.onSaved) ctrl.onSaved();
  };

  function onError(errorMsg) {
    ctrl.formError = errorMsg;
    ctrl.loading = false;
  };

  function parseForSave(office) {
    var office = _.cloneDeep(office);
    var phones = [{
      which: 'office',
      number: helpers.formatPhone(office.phone)
    }];

    delete office.phone;
    office.phones = phones;

    office.brokerId = ctrl.brokerage.id;

    return office;
  };

  function add() {
    var args = parseForSave(ctrl.subject);

    Service.add(args).then(onSave).catch(onError);
  };
};

function link($scope, el, attrs, ctrl) {
  $scope.$watchCollection('ctrl.brokerage', ctrl.setup);
};

angular.module('admin.directives').directive('address', ['HelperService', function (helpers) {
  return {
    restrict: 'A',
    controllerAs: 'addressCtrl',
    bindToController: {
      address: '=',
      brief: '@'
    },
    controller: angular.noop,
    templateUrl: function templateUrl(el, attrs) {
      if (!helpers.isFalsey(attrs.brief)) return '/admin/templates/partials/address-brief.html';

      return '/admin/templates/partials/address.html';
    },
    scope: {}
  };
}]);

angular.module('admin.directives').directive('avmCompare', ['Dictionary', function (Dictionary) {
  return {
    restrict: 'A',
    controllerAs: 'avmCtrl',
    bindToController: {
      home: '='
    },
    scope: {},
    templateUrl: '/admin/templates/partials/admins-avm-compare.html',

    controller: function controller() {
      var dictionary = new Dictionary();
      var ctrl = this;

      ctrl.lookup = function (prop, args, home) {
        return dictionary[prop](ctrl.home, args);
      };

      ctrl.avmDate = function (source) {
        if (!ctrl.home || !ctrl.home.avm) return 0;

        var avms = Helpers.sortByDate(_.filter(ctrl.home.avm, function (avm) {
          if (avm.source && avm.source === source && avm.rental !== true) {
            return true;
          } else return false;
        }), 'updated');

        return avms.length ? avms[0].updated : moment.invalid();
      };

      ctrl.getAVMCompareData = function () {
        var cl = ctrl.lookup('avmCoreLogic');
        var rt = ctrl.lookup('avmRealtyTrac');
        var z = ctrl.lookup('avmZillow');

        return {
          labels: ['Z', 'CL', 'RT'],
          series: [z, cl, rt]
        };
      };

      ctrl.avmCompareData = ctrl.getAVMCompareData();

      ctrl.getBarOptions = function () {
        return {
          axisX: {
            offset: 0,
            showGrid: false,
            showLabel: false
          },
          axisY: {
            showGrid: false,
            showLabel: true
          },
          distributeSeries: true,
          horizontalBars: true,
          seriesBarDistance: 0
        };
      };
    }
  };
}]);

angular.module('admin.directives').directive('agentBilling', [function () {
  return {
    restrict: 'A',
    controllerAs: 'agentBillingCtrl',
    bindToController: {
      agent: '='
    },
    scope: {},
    controller: angular.noop,
    templateUrl: '/admin/templates/agent-billing.html'
  };
}]);

angular.module('admin.directives').directive('agentClientList', ['Dictionary', 'AgentService', 'UtilService', '$window', function (Dictionary, AgentService, UtilService, $window) {
  return {
    restrict: 'EA',
    controllerAs: 'listCtrl',
    bindToController: {
      agent: '=',
      currentPage: '@',
      listType: '@',
      onSortChange: '&',
      clientListSort: '@',
      clientListOrder: '@',
      pageLimit: '@',
      searchQuery: '@'
    },
    scope: {},
    templateUrl: function templateUrl(el, attrs) {
      return attrs.templateUrl || '/admin/templates/partials/agent-client-list.html';
    },

    controller: function controller() {
      var ctrl = this;
      var dictionary = new Dictionary();

      ctrl.lookup = function (prop, home) {
        return dictionary[prop](home);
      };

      ctrl.doSearch = function () {
        var page = parseInt(ctrl.currentPage, 10);
        var limit = parseInt(ctrl.pageLimit, 10);
        var offset = (page - 1) * limit;

        if (ctrl.listType === 'needsCMA') return AgentService.needsCMA(ctrl.agent.id);else return AgentService.searchHomes(ctrl.agent.id, ctrl.searchQuery, ctrl.pageLimit, offset, ctrl.clientListSort, ctrl.clientListOrder);
      };

      ctrl.getHomes = function () {
        ctrl.error = '';
        ctrl.loading = true;

        ctrl.doSearch().then(function (data) {
          ctrl.homes = data;
          ctrl.loading = false;
        }).catch(function (err) {
          ctrl.loading = false;
          ctrl.error = 'There was an error getting your list of homes.';
          utils.trackException('Get All Homes', err);
        });
      };

      ctrl.sort = function (sort) {
        ctrl.onSortChange({ sort: sort });
      };

      ctrl.getHomes();
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watchGroup(['listCtrl.listType', 'listCtrl.searchQuery', 'listCtrl.currentPage', 'listCtrl.clientListSort', 'listCtrl.clientListOrder'], ctrl.getHomes);
    }

  };
}]);

angular.module('admin.directives').directive('agentImportClientsAction', ['AgentService', 'PageNotificationService', function (AgentService, PageNotificationService) {
  return {
    restrict: 'E',
    controllerAs: 'agentImportCtrl',
    bindToController: {
      agentId: '@'
    },
    scope: {},
    templateUrl: '/admin/templates/partials/agent-import-clients-action.html',

    controller: function controller() {
      var ctrl = this;

      ctrl.importClients = function () {
        if (!confirm('Import clients for this agent?')) return;

        ctrl.loading = true;

        return AgentService.importClients(ctrl.agentId).then(success).catch(error);
      };

      function success() {
        ctrl.loading = false;
        PageNotificationService.info('Successfully imported clients.');
      }

      function error(err) {
        ctrl.loading = false;
        PageNotificationService.info('There was an error importing clients.');
      }
    }
  };
}]);

angular.module('admin.directives').directive('agentSelector', ['AgentService', function (AgentService) {
  return {
    controllerAs: 'agentSelectorCtrl',
    bindToController: {},
    scope: {},
    restrict: 'A',
    template: '\n    <option value="">Select...</option>\n    <option ng-repeat="agent in agentSelectorCtrl.agents | orderBy : \'last_name\'" value="{{agent.id}}" track-by="agent.id">\n    {{agent.last_name}}, {{agent.first_name}}\n    </option>\n    ',
    controller: function controller() {
      var ctrl = this;

      AgentService.getAll({ filter: { where: { type: 'mortgage' } } }).then(function (agents) {
        ctrl.agents = agents;
      }).catch(function (e) {
        console.error('Error retrieving all agents', e);
      });
    }
  };
}]);

angular.module('admin.directives').directive('agentSendWelcomeAction', ['AgentService', 'PageNotificationService', function (AgentService, PageNotificationService) {
  return {
    restrict: 'E',
    controllerAs: 'sendWelcomeCtrl',
    bindToController: {
      agentId: '@'
    },
    scope: {},
    templateUrl: '/admin/templates/partials/agent-send-welcome-action.html',

    controller: function controller() {
      var ctrl = this;

      ctrl.sendWelcome = function () {
        ctrl.loading = true;

        return AgentService.sendWelcome(ctrl.agentId).then(success).catch(error);
      };

      function success() {
        ctrl.loading = false;
      }

      function error(err) {
        ctrl.loading = false;
        PageNotificationService.info('There was an error sending the welcome email.');
      }
    }
  };
}]);

if (typeof require !== 'undefined' && typeof _ === 'undefined') {
  var _ = require('lodash');
}

angular.module('admin.directives').directive('agentUserList', ['AgentService', 'UserService', 'FEATURES', function (AgentService, UserService, FEATURES) {
  return {
    restrict: 'EA',
    controllerAs: 'agentUserListCtrl',
    bindToController: {
      agent: '=',
      listType: '@'
    },
    scope: {},
    templateUrl: function templateUrl(el, attrs) {
      return attrs.templateUrl || '/admin/templates/partials/agent-user-list.html';
    },

    controller: function controller() {
      var ctrl = this;

      ctrl.doSearch = function () {
        if (ctrl.listType === 'emailIssues') return UserService.getUsersWithEmailIssues(ctrl.agent.id);

        if (ctrl.listType === 'invited') return UserService.getLeads(ctrl.agent.id);

        if (ctrl.listType === 'sharedClients') {
          return AgentService.sharedClients(ctrl.agent.id).then(function (data) {
            return _.uniq(data, function (datum) {
              return datum.userId;
            });
          }).then(function (data) {
            return _.filter(data, function (datum) {
              return datum.userId;
            });
          });
        }
      };

      ctrl.getUsers = function (showLoading) {
        ctrl.error = '';
        ctrl.loading = typeof showLoading !== 'undefined' ? showLoading : true;

        ctrl.doSearch().then(function (data) {
          ctrl.users = data;
          ctrl.loading = false;
        }).catch(function (err) {
          ctrl.loading = false;
          ctrl.error = 'There was an error getting your list of clients.';
        });
      };

      ctrl.editUser = function (user) {
        ctrl.userForEdit = user;
        ctrl.currentModal = 'editUser';
      };

      ctrl.closeModal = function () {
        ctrl.currentModal = null;
        ctrl.userForEdit = null;
      };

      ctrl.closeModalAndRefresh = function () {
        ctrl.closeModal();
        ctrl.getUsers(false);
      };

      ctrl.showV2Digest = _.contains(ctrl.agent.features, FEATURES.DIGEST_V2);

      ctrl.getUsers();
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watch('agentUserListCtrl.listType', function (oldVal, newVal) {
        if (oldVal !== newVal) ctrl.getUsers();
      });
    }

  };
}]);

angular.module('admin.directives').directive('clientList', ['Dictionary', 'HelperService', function (Dictionary, helpers) {
  return {
    restrict: 'EA',
    controllerAs: 'clientListCtrl',
    bindToController: {
      homes: '='
    },
    scope: {},
    templateUrl: function templateUrl(el, attrs) {
      return attrs.templateUrl || '/admin/templates/partials/client-list.html';
    },

    controller: function controller() {
      var ctrl = this;
      var dictionary = new Dictionary();

      ctrl.homesFilter = function (home) {
        return helpers.homesFilter(home, $scope.homeSearch);
      };

      ctrl.lookup = function (prop, home) {
        return dictionary[prop](home);
      };
    }

  };
}]);

angular.module('admin.directives').directive('datasourceViewer', ['HomeService', function (HomeService) {
  return {
    controllerAs: 'datasourceViewerCtrl',
    bindToController: {
      street: '@',
      unit: '@',
      zip: '@',
      homeId: '@'
    },
    scope: {},
    restrict: 'E',
    templateUrl: '/admin/templates/partials/datasource-viewer.html',
    controller: function controller() {
      var ctrl = this;

      ctrl.refreshData = function () {
        ctrl.err = false;
        ctrl.jsonData = false;
        ctrl.loading = true;

        if (!ctrl.homeDataView) return onSuccess();

        if (!ctrl.street || !ctrl.zip) return onError('Street and Zip are required.');

        return HomeService.lookupByDatasource({
          homeId: ctrl.homeId,
          format: getFormat(),
          source: getSource(),
          street: ctrl.street,
          unit: ctrl.unit,
          zip: ctrl.zip
        }).then(onSuccess).catch(onError);
      };

      function onSuccess(home) {
        ctrl.jsonData = home || null;
        ctrl.loading = false;
      };

      function onError(err) {
        ctrl.err = err;
        ctrl.loading = false;
      };

      function getSource() {
        return ctrl.homeDataView.split('|')[0];
      };

      function getFormat() {
        return ctrl.homeDataView.split('|')[1];
      }
    }
  };
}]);

angular.module('admin.directives').directive('datasourceViewerWithAddress', [function () {
  return {
    controllerAs: 'dataParentCtrl',
    bindToController: {},
    scope: {},
    restrict: 'E',
    templateUrl: '/admin/templates/partials/datasource-viewer-with-address.html',
    controller: function controller() {}
  };
}]);

angular.module('admin.directives').directive('editBrokerage', editBrokerage);

function editBrokerage() {

  return {
    bindToController: {
      onSaved: '&',
      onCancel: '&',
      subject: '='
    },
    controller: editBrokerageCtrl,
    controllerAs: 'ctrl',
    templateUrl: '/admin/templates/add-edit-brokerage.html',
    restrict: 'E',
    scope: {}
  };
};

editBrokerageCtrl.$inject = ['BrokerageService', 'HelperService'];

function editBrokerageCtrl(Service, helpers) {
  var ctrl = this;

  return _.merge(ctrl, {
    isEditMode: true,
    submit: save
  });

  /////

  function onSave() {
    ctrl.loading = false;

    if (ctrl.onSaved) ctrl.onSaved();
  };

  function onError(errorMsg) {
    ctrl.formError = errorMsg;
    ctrl.loading = false;
  };

  function parseForSave(subject) {
    subject = _.cloneDeep(subject);
    subject.phone = helpers.formatPhone(subject.phone);
    return subject;
  };

  function save() {
    ctrl.loading = true;
    var subject = parseForSave(ctrl.subject);

    Service.save(subject, ctrl.subject.id).then(onSave).catch(onError);
  };
};

angular.module('admin.directives').directive('editOffice', editOffice);

function editOffice() {

  return {
    bindToController: {
      office: '=',
      onCancel: '&',
      onSaved: '&'
    },
    controller: editOfficeCtrl,
    controllerAs: 'ctrl',
    link: link,
    templateUrl: '/admin/templates/add-edit-office.html',
    restrict: 'E',
    scope: {}
  };
};

editOfficeCtrl.$inject = ['OfficeService', 'HelperService'];

function editOfficeCtrl(Service, helpers) {
  var ctrl = this;

  return _.merge(ctrl, {
    remove: remove,
    isEditMode: true,
    setup: setup,
    submit: save
  });

  /////

  function setup() {
    if (!ctrl.office) return;

    ctrl.subject = parseForEditing(ctrl.office);
  };

  function onSave() {
    ctrl.loading = false;

    if (ctrl.onSaved) ctrl.onSaved();
  };

  function onError(errorMsg) {
    ctrl.formError = errorMsg;
    ctrl.loading = false;
  };

  function parseForSave(office) {
    var office = _.cloneDeep(office);
    var phones = [{
      which: 'office',
      number: helpers.formatPhone(office.phone)
    }];

    delete office.phone;
    office.phones = phones;

    return office;
  };

  function parseForEditing(office) {
    var office = _.cloneDeep(office);

    if (office.phones && office.phones.length) office.phone = office.phones[0].number;

    return office;
  };

  function save() {
    var args = parseForSave(ctrl.subject);

    Service.save(args, ctrl.subject.id).then(onSave).catch(onError);
  };

  function remove() {
    if (!confirm('Delete ' + ctrl.subject.name + ' office?')) return;

    Service.remove(ctrl.subject.id).then(onSave).catch(onError);
  };
};

function link($scope, el, attrs, ctrl) {
  $scope.$watchCollection('ctrl.office', ctrl.setup);
};

angular.module('admin.directives').directive('facebookShareButton', [function () {
  return {
    restrict: 'A',
    controllerAs: 'fbCtrl',
    bindToController: {
      agentId: '@',
      questionType: '@'
    },
    scope: {},
    templateUrl: '/admin/templates/partials/facebook-share-button.html',

    controller: function controller() {
      var ctrl = this;

      ctrl.shareUrl = 'https://get.homebot.ai/?agentId=' + ctrl.agentId + '&type=' + ctrl.questionType;

      ctrl.share = function () {
        FB.ui({
          method: 'share',
          href: ctrl.shareUrl,
          mobile_iframe: true
        }, function (response) {});
      };
    }
  };
}]);

angular.module('admin.directives').directive('heightHelper', ['$rootScope', '$timeout', function ($rootScope, $timeout) {
  return {
    restrict: 'A',

    link: function link($scope, el, attrs, ctrl) {

      function lockHeight(event, toState) {
        el.css('minHeight', el[0].offsetHeight + 'px');
      };

      function releaseHeight() {
        $timeout(function () {
          el.css('minHeight', '0px');
        }, 250);
      };

      var lockCleanup = $rootScope.$on('$stateChangeStart', lockHeight);
      var releaseCleanup = $rootScope.$on('$stateChangeSuccess', releaseHeight);

      $scope.$on('$destroy', lockCleanup); // removes from $rootScope
      $scope.$on('$destroy', releaseCleanup); // removes from $rootScope
    }

  };
}]);

angular.module('admin.directives').directive('homeFacts', ['HomeService', '$q', 'HelperService', function (HomeService, $q, helpers) {
  return {
    restrict: 'E',
    controllerAs: 'homeFactsCtrl',
    bindToController: {
      homeId: '=?',
      formContents: '@',
      factSet: '@',
      onSaved: '&',
      onCancel: '&',
      onDelete: '&',
      showDelete: '=?',
      home: '=',
      answers: '=?'
    },
    scope: {},
    templateUrl: '/admin/templates/partials/home-facts.html',

    controller: function controller() {
      var ctrl = this;
      ctrl.maxDate = moment();
      ctrl.minDate = moment('1776-07-04', helpers.dateFormat);

      var findAnswer = function findAnswer(question) {
        return _.result(_.find(ctrl.answers, 'question', question), 'answer');
      };
      var integerLoader = function integerLoader(name) {
        return function () {
          return parseInt(findAnswer(editableFacts[name].question) || ctrl.home[name] || 0);
        };
      };
      var bathroomsLoader = function bathroomsLoader() {
        try {
          var answer = findAnswer(editableFacts.bathrooms.question);
          return _.mapValues(JSON.parse('{' + answer + '}'), parseInt);
        } catch (err) {
          return {};
        }
      };
      var dateLoader = function dateLoader() {
        var question = editableFacts.soldDate.question;
        var unparsedDate = findAnswer(question) || ctrl.home.soldDate;
        var m = moment(unparsedDate, helpers.dateFormat);
        return {
          day: m.date(),
          month: m.month() + 1,
          year: m.year()
        };
      };

      var factSets = {
        physical: {
          bathrooms: {
            loader: bathroomsLoader,
            answerCreator: function answerCreator(fact) {
              return JSON.stringify(fact).replace(/[{}]/g, '');
            },
            question: 'fact:bathrooms'
          },
          bedrooms: {
            loader: integerLoader('bedrooms'),
            answerCreator: _.identity,
            question: 'fact:bedrooms'
          },
          finishedSqFt: {
            loader: integerLoader('finishedSqFt'),
            answerCreator: _.identity,
            question: 'fact:finishedSqFt'
          }
        },
        sale: {
          soldPrice: {
            loader: integerLoader('soldPrice'),
            answerCreator: _.identity,
            question: 'fact:soldPrice'
          },
          soldDate: {
            loader: dateLoader,
            answerCreator: function answerCreator(_ref3) {
              var year = _ref3.year,
                  month = _ref3.month,
                  day = _ref3.day;
              return year + '-' + month + '-' + day;
            },
            question: 'fact:soldDate',
            inputValidator: function inputValidator(_ref4) {
              var year = _ref4.year,
                  month = _ref4.month,
                  day = _ref4.day;

              var m = moment({ year: year, month: month - 1, day: day });
              if (!m.isValid()) throw 'Please enter a valid month, day and year.';
              if (m.isAfter(ctrl.maxDate)) throw 'You cannot enter a date in the future.';
              if (m.isBefore(ctrl.minDate)) throw 'Please enter a date after July 4th, 1776.';
            }
          }
        }
      };

      var editableFacts = Object.assign({}, factSets.physical, factSets.sale);
      var selectedFactNames = Object.keys(factSets[ctrl.factSet]);
      var selectedQuestions = selectedFactNames.map(function (name) {
        return editableFacts[name].question;
      });

      ctrl.submit = function () {
        ctrl.successful = null;
        ctrl.error = null;
        ctrl.add();
      };

      var parseForSaving = function parseForSaving() {
        return selectedFactNames.reduce(function (answers, factName) {
          var _editableFacts$factNa = editableFacts[factName],
              question = _editableFacts$factNa.question,
              answerCreator = _editableFacts$factNa.answerCreator,
              inputValidator = _editableFacts$factNa.inputValidator;

          var newFact = ctrl.facts[factName];

          if (!_.isEqual(newFact, ctrl.originalFacts[factName])) {
            if (inputValidator) inputValidator(newFact);
            answers[question] = answerCreator(newFact);
          }

          return answers;
        }, {});
      };

      ctrl.cancel = function () {
        ctrl.facts = _.cloneDeep(ctrl.originalFacts);
        ctrl.facts.bathrooms = bathroomDefaults();
        ctrl.error = null;
        ctrl.onCancel();
      };

      ctrl.add = function () {
        var answers = {};

        try {
          answers = parseForSaving();
        } catch (e) {
          error(e);
          return;
        }

        ctrl.saving = true;
        HomeService.saveAnswers(answers, ctrl.homeId).then(success).catch(error);
      };

      ctrl.deleteAnswers = function () {
        if (!confirm('Are you sure you want to reset to Homebot data?')) {
          return;
        }

        ctrl.saving = true;
        ctrl.error = '';

        var deleteRequests = ctrl.answers.reduce(function (answersToDelete, answer) {
          var answerSelectedForDelete = selectedQuestions.indexOf(answer.question) >= 0;
          return answerSelectedForDelete ? answersToDelete.concat(HomeService.deleteAnswer(answer.id, ctrl.homeId)) : answersToDelete;
        }, []);

        $q.all(deleteRequests).then(function () {
          return HomeService.recompileHome(ctrl.homeId);
        }).then(function (home) {
          return ctrl.home = home;
        }).then(success).catch(error);
      };

      var success = function success(savedHome) {
        ctrl.successful = true;
        ctrl.error = null;
        ctrl.saving = false;
        savedHome && ctrl.resetAdd();
        ctrl.onSaved();
      };

      var error = function error(err) {
        ctrl.error = typeof err === 'string' ? err : 'There was an error saving your home facts. Please try again or contact support.';
        ctrl.saving = false;
      };

      var bathroomDefaults = function bathroomDefaults() {
        var baths = ctrl.facts.bathrooms;
        return {
          full: typeof baths.full !== 'undefined' ? baths.full : parseInt(ctrl.home.bathrooms),
          threeQuarters: baths.threeQuarters || 0,
          half: baths.half || 0,
          quarter: baths.quarter || 0
        };
      };

      var loadAnswers = function loadAnswers() {
        if (!ctrl.homeId) {
          return;
        }

        ctrl.facts = {};

        HomeService.getAnswers(ctrl.homeId).then(function (unsortedAnswers) {
          var sortedAnswers = _.sortByOrder(unsortedAnswers, 'updated', 'desc');
          var questions = Object.values(editableFacts).map(function (_ref5) {
            var question = _ref5.question;
            return question;
          });
          ctrl.answers = _.filter(sortedAnswers, function (_ref6) {
            var question = _ref6.question;
            return questions.indexOf(question) >= 0;
          });
          Object.keys(editableFacts).forEach(function (name) {
            return ctrl.facts[name] = editableFacts[name].loader();
          });
          ctrl.originalFacts = _.cloneDeep(ctrl.facts);
          ctrl.facts.bathrooms = bathroomDefaults();
          ctrl.showDelete = ctrl.answers.length > 0;
          ctrl.loading = false;
        }).catch(function (err) {
          return utils.trackException('Admin view home answers', err);
        });
      };

      ctrl.resetAdd = function () {
        ctrl.showDelete = false;
        loadAnswers();
      };

      ctrl.resetAdd();
    }
  };
}]);

angular.module('admin.directives').directive('impersonationBar', ['SessionService', 'APP_CONFIG', function (SessionService, APP_CONFIG) {
  return {
    restrict: 'E',
    controllerAs: 'impersonationBarCtrl',
    bindToController: {},
    scope: {},
    templateUrl: '/admin/templates/partials/impersonation-bar.html',

    controller: function controller() {
      var ctrl = this;

      ctrl.agentIsImpersonated = function () {
        if (_.isEmpty(SessionService.getLockboxToken())) {
          return false;
        }

        var tokenData = SessionService.extractJWT();

        if (tokenData.name) {
          ctrl.currentUserName = tokenData.name[0] + ' ' + tokenData.name[1];
        }

        return (/^homebot:imp$/.test(tokenData.kind)
        );
      };

      ctrl.backToDashboard = function () {
        window.location.href = APP_CONFIG.MAINSTREET_URL + '/auth/company-admin';
      };
    },

    link: function link($scope, el, attrs, ctrl) {}
  };
}]);

angular.module('admin.directives').directive('inputFocus', ['$timeout', function ($timeout) {
  return {
    link: function link(_scope, element, _attrs) {
      $timeout(function () {
        element[0].focus();
      });
    }
  };
}]);

angular.module('admin.directives').directive('integerInput', [function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs, ngModel) {
      var input = element[0];
      input.oninvalid = function () {
        input.setCustomValidity('Please enter a whole number, no decimals');
      };
      input.oninput = function () {
        input.setCustomValidity('');
      };
    }
  };
}]);

angular.module('admin.directives').directive('legal', ['AgentService', 'PageNotificationService', '$state', 'AccountService', 'SessionService', function (AgentService, PageNotificationService, $state, AccountService, SessionService) {
  return {
    restrict: '',
    controllerAs: 'legalCtrl',
    bindToController: {},
    scope: {},
    templateUrl: '/admin/templates/partials/legal.html',

    controller: function controller() {
      var ctrl = this;

      ctrl.agentHasLoaded = function () {
        return !_.isEmpty(AccountService.getAgent());
      };

      ctrl.requiresLegalAcceptance = function () {
        return !SessionService.isImpersonating() && !Boolean(AccountService.getAgent('legalAcceptedAt'));
      };

      ctrl.acceptLegal = function () {
        if (ctrl.acceptedLegal) {
          (function () {
            var acceptedAt = moment().toDate();

            AgentService.acceptTerms(AccountService.getAgent('id')).then(function () {
              var agent = AccountService.getAgent();
              agent.legalAcceptedAt = acceptedAt;
              AccountService.set(agent);
              PageNotificationService.close();
            }).catch(function (err) {
              PageNotificationService.error('There was an error saving agent profile. ' + err);
            });
          })();
        } else {
          PageNotificationService.error('Please accept the Terms of Service and Privacy Policy before continuing.');
        }
      };
    },

    link: function link($scope, el, attrs, ctrl) {}
  };
}]);

angular.module('admin.directives').directive('officeSelector', ['BrokerageService', 'PageNotificationService', function (BrokerageService, PageNotificationService) {
  return {
    controllerAs: 'officeSelectorCtrl',
    bindToController: {
      'brokerageId': '='
    },
    scope: {},
    restrict: 'A',
    template: '\n    <option value="">Select...</option>\n    <option ng-repeat="office in officeSelectorCtrl.offices" value="{{office.id}}" track-by="office.id">\n      {{office.name}}\n    </option>\n    ',
    controller: function controller() {
      var ctrl = this;

      BrokerageService.getOffices(ctrl.brokerageId).then(function (offices) {
        ctrl.offices = offices;
      }).catch(function (e) {
        PageNotificationService.error('Error retrieving all offices', e);
      });
    }
  };
}]);

angular.module('admin.directives').directive('realEstateAgents', ['HelperService', 'RealEstateAgentService', 'AgentService', function (helpers, RealEstateAgentService, AgentService) {
  return {
    restrict: 'EA',
    controllerAs: 'reAgentsCtrl',
    bindToController: {
      agent: '='
    },
    scope: {},
    templateUrl: function templateUrl(el, attrs) {
      return attrs.templateUrl || '/admin/templates/partials/real-estate-agents-list.html';
    },

    controller: function controller() {
      var ctrl = this;
      ctrl.loading = true;

      ctrl.refreshData = function () {
        function onSuccess(agents) {
          ctrl.agents = helpers.sortRealEstateAgents(agents);
          ctrl.loading = false;
        }

        function onError(err) {
          ctrl.error = err;
        };

        AgentService.realEstateAgents(ctrl.agent.id).then(onSuccess).catch(onError);
      };

      ctrl.refreshData();
    }
  };
}]);

angular.module('admin.directives').directive('sortHeader', [function () {
  return {
    restrict: 'EA',
    controllerAs: 'sortCtrl',
    bindToController: {
      onSort: '&',
      sortActive: '@',
      sortHeader: '@',
      sortOrder: '@'
    },
    scope: {},
    transclude: true,
    template: '\n      <a href=""\n        class="sort-header"\n        ng-transclude\n        ng-click="sortCtrl.sort()"\n        ng-class="{\n          \'sort-header--active\': sortCtrl.isActive(),\n          \'sort-header--asc\': sortCtrl.sortOrder === \'ASC\' && sortCtrl.isActive()\n        }"\n      ></a>\n    ',

    controller: function controller() {
      var ctrl = this;

      ctrl.sort = function () {
        ctrl.onSort({ sort: ctrl.sortHeader, order: ctrl.sortOrder });
      };

      ctrl.isActive = function () {
        return ctrl.sortHeader === ctrl.sortActive;
      };
    }
  };
}]);

angular.module('admin.directives').directive('sponsoredAgentList', ['AgentService', function (AgentService) {
  return {
    restrict: 'EA',
    controllerAs: 'sponsoredAgentListCtrl',
    bindToController: {
      agent: '='
    },
    scope: {},
    templateUrl: '/admin/templates/partials/sponsored-agent-list.html',

    controller: function controller() {
      var ctrl = this;
      ctrl.reas = [];

      function refreshData() {
        ctrl.loading = true;

        AgentService.getSponsoredAgents(ctrl.agent.id).then(function (data) {
          ctrl.loading = false;
          ctrl.error = null;
          ctrl.reas = data;
        }).catch(function (errorMessage) {
          ctrl.error = errorMessage;
        });
      }

      refreshData();
    }
  };
}]);

angular.module('admin.directives').directive('stat', ['Dictionary', 'HelperService', 'HomeService', 'AgentService', 'UserService', 'LoanService', 'HomeActivity', function (Dictionary, Helpers, HomeService, AgentService, UserService, LoanService, HomeActivity) {
  return {
    restrict: 'EA',
    controllerAs: 'statCtrl',
    bindToController: {
      startDate: '=',
      agentId: '@',
      stat: '@'
    },
    scope: {},
    template: '{{statCtrl.statVal | number}}',

    controller: function controller() {
      var dataCall;
      var ctrl = this;
      var where = {};

      function success(statVal) {
        ctrl.statVal = statVal.count;
      }

      function error(err) {
        ctrl.error = err;
      }

      if (ctrl.agentId) where.agentId = ctrl.agentId;

      if (ctrl.startDate) where.created = { gte: moment(ctrl.startDate).toDate() };

      if (ctrl.stat === 'agents') dataCall = AgentService.count;else if (ctrl.stat === 'homes') dataCall = HomeService.count;else if (ctrl.stat === 'users') dataCall = UserService.count;else if (ctrl.stat === 'loans') dataCall = LoanService.count;else if (ctrl.stat === 'digests-texted') {
        dataCall = HomeActivity.count;
        where.source = "twilio";
        where.event = "sent";
      } else if (ctrl.stat === 'text-clicks') {
        dataCall = HomeActivity.count;
        where.source = "twilio";
        where.event = "view";
      } else if (ctrl.stat === 'digests-emailed') {
        dataCall = HomeActivity.count;
        where.source = "mandrill";
        where.event = "sent";
      } else if (ctrl.stat === 'email-opens') {
        dataCall = HomeActivity.count;
        where.source = "mandrill";
        where.event = "open";
      } else if (ctrl.stat === 'email-clicks') {
        dataCall = HomeActivity.count;
        where.source = "mandrill";
        where.event = "click";
      } else if (ctrl.stat === 'web-views') {
        dataCall = HomeActivity.count;
        where.event = "view";
      } else if (ctrl.stat === 'cma-request') {
        dataCall = HomeActivity.count;
        where.source = "user";
        where.event = "cma-request";
      } else if (ctrl.stat === 'unsent-users') {
        dataCall = UserService.count;
        where.digestHasBeenSent = false;
      } else if (ctrl.stat === 'invalid-users') {
        dataCall = UserService.count;
        where.emailValid = false;
      }
      // else if(ctrl.stat === 'unsubscribed-users'){
      //   dataCall = UserService.count;
      //   where.digestEmailUnsubscribed = {neq: true};
      // }

      ctrl.refreshData = function () {
        dataCall({ where: where }).then(success).catch(error);
      };

      ctrl.refreshData();
    }
  };
}]);

angular.module('admin.directives').directive('stream', ['Dictionary', '$interval', 'HomeActivity', 'UtilService', 'ActivityDictionary', function (Dictionary, $interval, HomeActivity, utils, ActivityDictionary, undefined) {
  return {
    restrict: 'E',
    controllerAs: 'streamCtrl',
    bindToController: {
      autoRefresh: '@',
      agentId: '@',
      homeId: '@',
      limit: '@',
      userId: '@',
      streamStyle: '@',
      type: '@'
    },
    scope: {},
    templateUrl: function templateUrl(el, attrs) {
      if (attrs.type === 'client') return '/admin/templates/partials/stream-client.html';else if (attrs.type === 'agent') return '/admin/templates/partials/stream-agent.html';

      return '/admin/templates/partials/stream-all.html';
    },

    controller: ['$scope', '$interval', function ($scope, $interval) {
      var lastTimeRefreshed;
      var ctrl = this;
      var where = {};
      var include;
      var limit;
      var refresher = undefined;
      var activityDictionary = new ActivityDictionary();

      ctrl.loadingFirstBatch = true;

      ctrl.activity = [];

      if (ctrl.type === 'agent') where = {
        agentId: ctrl.agentId,
        event: ["open", "spam", "soft_bounce", "hard_bounce", "cma-notify-client", "cma-request", "view", "reject", "viewedRefiDetails", "viewed-market-panel", "viewed-home-insurance-panel"]
      };else if (ctrl.type === 'client') where = { userId: ctrl.userId, homeId: ctrl.homeId };

      if (ctrl.type === 'admin') include = ['user', 'agent'];

      ctrl.refresh = function () {
        if (!where) throw new Error('Where not defined on stream');

        if (lastTimeRefreshed) where.created = { gte: lastTimeRefreshed };

        limit = ctrl.limit || null;

        HomeActivity.getActivity(where, include, limit).then(function (activity) {
          activity = activity || [];

          if (ctrl.type === 'agent') ctrl.activity = ctrl.lookupActivity('sortAndGroupEvents', activity).concat(ctrl.activity);else ctrl.activity = activity.concat(ctrl.activity);

          lastTimeRefreshed = moment().toDate();
          ctrl.loadingFirstBatch = false;
        }).catch(function (err) {
          ctrl.errorMsg = 'There was an error loading activity';
          utils.trackException('Get Activity', err);
        });
      };

      ctrl.lookupActivity = function (prop, stream) {
        stream = stream || ctrl.activity;
        return activityDictionary[prop](stream);
      };

      function startRefresher() {
        if (refresher) return;

        refresher = $interval(function () {
          ctrl.refresh();
        }, 1000 * 60);
      };

      function stopRefresher() {
        if (refresher) $interval.cancel(refresher);

        refresher = undefined;
      };

      $scope.$on('$destroy', stopRefresher);

      if (ctrl.autoRefresh === 'true') startRefresher();

      ctrl.refresh();
    }]
  };
}]);

angular.module('admin.directives').directive('trialBanner', [function () {
  return {
    controllerAs: 'trialBannerCtrl',
    bindToController: {
      isBabAgent: '@',
      trialDaysLeft: '@'
    },
    scope: {},
    templateUrl: '/admin/templates/partials/trial-banner.html',

    controller: function controller() {}
  };
}]);

angular.module('admin.directives').directive('userHomesList', ['UserService', 'UserHomesService', function (UserService, UserHomesService) {
  return {
    restrict: 'EA',
    controllerAs: 'userHomesListCtrl',
    bindToController: {
      agentId: '=',
      userId: '=',
      showSharedToggle: '=?'
    },
    scope: {},
    templateUrl: '/admin/templates/partials/user-homes-list.html',

    controller: function controller() {
      var ctrl = this;

      ctrl.refresh = function () {
        UserService.getUserHomes(ctrl.userId).then(function (homes) {
          ctrl.loading = false;
          ctrl.homes = homes;
        }).catch(function (err) {
          ctrl.error = err;
        });
      };

      ctrl.toggle = function (currentStatus, userHomeId) {
        var shouldEnable = ['disabled', 'forceDisabled'].includes(currentStatus);

        function updateDigestStatusAndRefresh(digestStatus) {
          UserHomesService.updateDigestStatus(userHomeId, digestStatus).then(function () {
            ctrl.refresh();
          });
        }

        if (shouldEnable) {
          if (confirm('Are you sure you want to enable the duplicate digest?')) {
            ctrl.loading = true;
            updateDigestStatusAndRefresh('forceEnabled');
          }
        } else {
          ctrl.loading = true;
          updateDigestStatusAndRefresh('forceDisabled');
        }
      };

      ctrl.refresh();
    }

  };
}]);

var EventSentenceFilter = function EventSentenceFilter($filter) {
  return function (event, fullName, linkToUser) {
    var displayName = '';

    if (event.user) {
      displayName = event.user.first_name;

      if (fullName) displayName += ' ' + event.user.last_name;

      if (linkToUser && event.homeId && event.agentId) displayName = '<a ui-sref="agent.homeDetail({homeId:event.homeId,id:event.agentId})">' + displayName + '</a>';
    }

    if (event.event === 'client-add-home') {
      return displayName + ' added a home to their profile.';
    }

    if (event.source === 'mandrill') {

      if (event.event === 'click') return displayName + ' clicked on the email.';
      if (event.event === 'view') return displayName + ' viewed the digest from the email.';
      if (event.event === 'open') return displayName + ' opened the email.';
      if (event.event === 'sent') return 'Digest was emailed to ' + displayName + '.';
      if (event.event === 'spam') return displayName + ' marked the digest as spam.';
      if (event.event === 'soft_bounce' || event.event === 'hard_bounce') return 'Digest was sent to ' + displayName + ', but the email bounced.';
      if (event.event === 'reject') return 'Digest was sent to ' + displayName + ', but the email was rejected.';
      if (event.event === 'equity-opportunity-sent') return 'Equity email was sent to ' + displayName + '.';
      if (event.event === 'equity-opportunity-open') return displayName + ' opened the equity email.';
      if (event.event === 'equity-opportunity-click') return displayName + ' clicked on the equity email.';
      if (event.event === 'home-market-sent') return 'Home market report was emailed to ' + displayName + '.';
      if (event.event === 'home-market-open') return displayName + ' opened their home market email.';
      if (event.event === 'home-market-click') return displayName + ' clicked on their home market email.';
    } else if (event.source === 'sms') {

      if (event.event === 'view') return displayName + ' viewed the digest from the text message';
    } else if (event.source === 'twilio') {

      if (event.event === 'view' || event.event === 'open') // our twilio open event is deprecated,safe to remove 9/15
        return displayName + ' clicked on the text message.';
      if (event.event === 'sent') return 'Digest was texted to ' + displayName + '.';
    } else if (event.source === 'agent') {

      //event.amount and event.diff are available
      if (event.event === 'avm-up') return 'You raised the value of ' + displayName + '\'s home by ' + $filter('money')(event.diff) + ' with a new CMA.';
      if (event.event === 'avm-down') return 'You lowered the value of ' + displayName + '\'s home by ' + $filter('money')($filter('abs')(event.diff)) + ' with a new CMA.';
      if (event.event === 'cma-notify-client') return 'You notified ' + displayName + ' of the CMA.';
    } else if (event.source === 'homebot') {

      //event.amount and event.diff are available
      if (event.event === 'avm-up') return displayName + '\'s AVM went up ' + $filter('money')(event.diff) + ' for the month.';
      if (event.event === 'avm-down') return displayName + '\'s AVM went down ' + $filter('money')($filter('abs')(event.diff)) + ' for the month.';
      if (event.event === 'loan-new') return 'A new loan was added for ' + displayName + '.';
      if (event.event === 'RT_migration') return displayName + '\'s AVM and history were updated to Homebot\'s new algorithm.';
      if (event.event === 'shifted-to-monthly-digests') return displayName + ' has re-engaged with Homebot emails and is back on a monthly send schedule!';
      if (event.event === 'shifted-to-quarterly-digests') return displayName + ' hasn\'t looked at their Homebot emails in six months so has been moved to a quarterly email.';
      if (event.event === 'client-referral-sign-up') return event.properties.referred_client_name + ' signed up for Homebot from a referral by ' + displayName;
    } else if (event.source === 'user') {

      if (event.event === 'cma-request') return 'CMA Requested by ' + displayName + '.';

      if (event.event === 'view') return displayName + ' viewed the digest.';

      if (event.event === 'messageAgent' || event.event === 'homeowner-direct-message') {

        if (event.properties && event.properties.topic && event.properties.message) return displayName + (' wants to know more about ' + event.properties.topic + ': "' + event.properties.message + '"');

        return displayName + ' sent you a message.';
      }

      if (event.event === 'mortgage-coach-tca-requested') {
        if (event.properties) {
          if (event.properties.loan_params.loan_term_years) {
            if (event.properties.loan_params.loan_type === 'ARM') {
              return 'TCA requested by ' + displayName + ' for a ' + event.properties.loan_params.arm_years_initial + '/1-arm refi.';
            }
            return 'TCA requested by ' + displayName + ' for a ' + event.properties.loan_params.loan_term_years + '-year refi.';
          }
          return 'TCA requested by ' + displayName + '.';
        }
      }

      if (event.event === 'mortgage-coach-tca-updated') {
        if (event.properties) {
          if (event.properties.loan_params.loan_term_years) {
            if (event.properties.loan_params.loan_type === 'ARM') {
              return displayName + ' added a ' + event.properties.loan_params.arm_years_initial + '/1-arm refi scenario to their TCA.';
            }
            return displayName + ' added a ' + event.properties.loan_params.loan_term_years + '-year refi scenario to their TCA.';
          }
        }
      }

      if (event.event === 'sms-subscribe') return displayName + ' enabled text updates.';

      if (event.event === 'sms-unsubscribe') return displayName + ' disabled text updates.';

      if (event.event === 'homeInsuranceCovered') return displayName + ' explored home insurance options.';

      if (event.event === 'viewed-dream-home-panel') return displayName + ' viewed the new home panel.';

      if (event.event === 'viewed-home-insurance-panel') return displayName + ' explored more details on home insurance.';

      if (event.event === 'refiSliderInteraction') return displayName + ' explored refi timelines.';

      if (event.event === 'viewedRefiDetails') return displayName + ' explored more details on a refi option.';

      if (event.event === 'viewed-market-panel') return displayName + ' viewed home\'s market stats.';

      if (event.event === 'referral-invite-sent') return displayName + ' shared Homebot with a friend';

      if (event.event === 'updated-loan-balance') {
        if (event.properties && event.properties.balance_diff && event.properties.balance) {
          var balanceDiff = parseInt(event.properties.balance_diff);
          var extraOrLess = balanceDiff > 0 ? 'extra' : 'less';

          return displayName + '  updated their loan balance to ' + $filter('money')(event.properties.balance) + '. This means they have paid a total of ' + $filter('money')($filter('abs')(balanceDiff)) + ' ' + extraOrLess + ' towards principal over the life of the loan';
        }
      }

      if (event.event === 'instant-offer-requested') {
        return displayName + ' requested to learn more about instant offers';
      }

      if (event.event === 'client-tuned-value') {
        if (event.properties && event.properties.valuation_amount) {

          return displayName + ' tuned their value to ' + $filter('money')(event.properties.valuation_amount) + '.';
        }
      }

      if (event.event === 'client-updated-mobile-number') {
        return displayName + ' updated their phone number.';
      }

      if (event.event === 'updated-insurance-policy-start-date') {
        if (event.properties && event.properties.date) {
          var date = moment(event.properties.date).format('MM/DD/YYYY');

          return displayName + ' updated their home insurance policy start date to ' + date;
        }

        return displayName + ' updated their home insurance policy details';
      }
    }

    return '';
  };
};

if (typeof module !== 'undefined' && module.exports) {
  module.exports = EventSentenceFilter;
} else if (typeof window !== 'undefined') {
  window.EventSentenceFilter = EventSentenceFilter;
}

if (typeof require !== 'undefined') Factory = require('../../../app/js/lib/Factory.js');

var MailtoFactory = function (_Factory) {
  _inherits(MailtoFactory, _Factory);

  function MailtoFactory(options) {
    _classCallCheck(this, MailtoFactory);

    return _possibleConstructorReturn(this, (MailtoFactory.__proto__ || Object.getPrototypeOf(MailtoFactory)).call(this, options));
  }

  _createClass(MailtoFactory, [{
    key: 'buildMailto',
    value: function buildMailto() {
      return this._buildTo() + '?subject=' + this._buildSubject() + '&body=' + this._buildBody();
    }
  }, {
    key: 'lookup',
    value: function lookup(prop, args) {
      return this.dictionary[prop](this.home, args);
    }
  }, {
    key: '_buildTo',
    value: function _buildTo() {
      return this._to();
    }
  }, {
    key: '_buildSubject',
    value: function _buildSubject() {
      return encodeURI(this._subject());
    }
  }, {
    key: '_buildBody',
    value: function _buildBody() {
      var body = this._body();
      body = body.replace(/&/g, 'and');
      return encodeURI(body);
    }
  }]);

  return MailtoFactory;
}(Factory);

if (typeof module !== 'undefined' && module.exports) module.exports = MailtoFactory;else if (typeof window !== 'undefined') window.MailtoFactory = MailtoFactory;

angular.module('admin.services').factory('MailtoService', ['Dictionary', 'HelperService', '$filter', function (Dictionary, helpers, $filter) {

  function createPreferredReaCmaRequest(options) {
    options = Object.assign({ dictionary: new Dictionary(), helpers: helpers, $filter: $filter }, options);
    return new PreferredReaCmaRequest(options);
  }

  function createRecommendedReaCmaRequest(options) {
    options = Object.assign({ dictionary: new Dictionary(), helpers: helpers, $filter: $filter }, options);
    return new RecommendedReaCmaRequest(options);
  };

  function createMlsProInvite(options) {
    options = Object.assign({ dictionary: new Dictionary(), helpers: helpers, $filter: $filter }, options);
    return new MlsProInviteMailtoString(options);
  };

  function createSponsorAgentInvite(options) {
    options = Object.assign({ dictionary: new Dictionary(), helpers: helpers, $filter: $filter }, options);
    return new SponsorAgentInviteMailtoString(options);
  };

  return {
    create: function create(type, options) {
      if (type === 'preferredRea') return createPreferredReaCmaRequest(options);else if (type === 'recommendedRea') return createRecommendedReaCmaRequest(options);else if (type === 'mlsProInvite') return createMlsProInvite(options);else if (type === 'sponsorAgentInvite') return createSponsorAgentInvite(options);
    }
  };
}]);

if (typeof require !== 'undefined') {
  MailtoFactory = require('../mailtos/mailto-factory.js');
  _ = require('lodash');
}

var MlsProInviteMailtoString = function (_MailtoFactory) {
  _inherits(MlsProInviteMailtoString, _MailtoFactory);

  function MlsProInviteMailtoString(options) {
    _classCallCheck(this, MlsProInviteMailtoString);

    if (!options.rea || !options.agent) console.warn('Rea and Agent are required for mailto.');

    return _possibleConstructorReturn(this, (MlsProInviteMailtoString.__proto__ || Object.getPrototypeOf(MlsProInviteMailtoString)).call(this, options));
  }

  _createClass(MlsProInviteMailtoString, [{
    key: '_to',
    value: function _to() {
      return this.rea.email;
    }
  }, {
    key: '_subject',
    value: function _subject() {
      return 'Our clients (e.g. ' + this._getClientNamesForSubject() + ') on Homebot';
    }
  }, {
    key: '_getClientNamesForSubject',
    value: function _getClientNamesForSubject() {
      return this._getClientNames()[0];
    }
  }, {
    key: '_getClientNamesForBody',
    value: function _getClientNamesForBody() {
      return this._getClientNames().slice(0, 5).join(', ');
    }
  }, {
    key: '_getClientNames',
    value: function _getClientNames() {
      return this.rea.homes.map(function (home) {
        return home.users[0].first_name + ' ' + home.users[0].last_name;
      });
    }
  }, {
    key: '_body',
    value: function _body() {
      return 'Hi ' + this.rea.first_name + ',\n\nI\'m providing a new service called Homebot to all of my clients (and they love it). It monitors their home value, loans, and market conditions to optimize home finance decisions (e.g. when to refi, when to buy/sell/rent, etc). Click on this link to see what it looks like (http://get.homebotapp.com/agent/)\n\nI wanted to give you a heads up because we share the following clients that are getting Homebot: ' + this._getClientNamesForBody() + '\n\nHomebot lets the client request an updated home value and when they do, I forward that request to you.  It\'s great for new listings/referrals and keeping you from getting "Zillow\'d" with your existing clients!\n\nHere\'s a link for more information (http://www.homebot.ai) or just give me a buzz anytime.   There\'s also a version for real estate agents and if you\'re interested, I\'d be happy to co-sponsor it for you!\n\n' + this.agent.first_name + ' ' + this.agent.last_name;
    }
  }]);

  return MlsProInviteMailtoString;
}(MailtoFactory);

if (typeof module !== 'undefined' && module.exports) module.exports = MlsProInviteMailtoString;else if (typeof window !== 'undefined') window.MlsProInviteMailtoString = MlsProInviteMailtoString;

var PreferredReaCmaRequest = function (_MailtoFactory2) {
  _inherits(PreferredReaCmaRequest, _MailtoFactory2);

  function PreferredReaCmaRequest(options) {
    _classCallCheck(this, PreferredReaCmaRequest);

    return _possibleConstructorReturn(this, (PreferredReaCmaRequest.__proto__ || Object.getPrototypeOf(PreferredReaCmaRequest)).call(this, options));
  }

  _createClass(PreferredReaCmaRequest, [{
    key: 'homeValue',
    value: function homeValue() {
      _.get(this.home, 'metadata.homeValue');
    }
  }, {
    key: '_to',
    value: function _to() {
      return this.rea.email;
    }
  }, {
    key: '_subject',
    value: function _subject() {
      return this.user.first_name + ' ' + this.user.last_name + ' wants a CMA';
    }
  }, {
    key: '_body',
    value: function _body() {

      return 'Hi ' + this.rea.first_name + ',\n\nWe have a shared client, ' + this.user.first_name + ' ' + this.user.last_name + ', and they asked me through Homebot if you would give them a new estimated value. Are you able to do a current market analysis for them?\n\nHomebot makes this pretty easy for both of us.  Once you have a new value, give me a call or email and then I\'ll update their Homebot.  You\'ll get credit with your photo and contact info every month going forward.\n\nThe details:\n\n' + this.$filter('clientNamesForwards')(this.home) + '\n- ' + this.helpers.displayAddress(this.home.address) + '\n- When you sold it: ' + this.$filter('moment')(this.home.soldDate, 'MMMM, YYYY') + '\n' + this._estimateBullet() + '\n' + this._updatesBullet() + '\n\n' + this.user.first_name + '\'s phone: ' + this.$filter('phone')(this.user.mobile) + '\nEmail: ' + this.user.email + '\n\nLet me know what you think the value is!\n\n' + this.agent.first_name + ' ' + this.agent.last_name + '\nDon\'t hesitate to call me with questions: ' + this.$filter('phone')(this.$filter('mobile')(this.agent.phones)) + '\n\n\nP.S. You can learn more about homebot here: http://homebot.ai/cma';
    }
  }, {
    key: '_updatesBullet',
    value: function _updatesBullet() {
      if (!this.home.answers.homeUpdatedDescription) return '';

      return '- Updates they made to the home: "' + this.home.answers.homeUpdatedDescription + '"';
    }
  }, {
    key: '_estimateBullet',
    value: function _estimateBullet() {
      if (!this.home.answers.isEstimateCorrect) return '';

      return '- They believe that ' + this.$filter('money')(this.homeValue()) + ' is ' + this.$filter('estimateCorrect')(this.home.answers.isEstimateCorrect) + '.';
    }
  }]);

  return PreferredReaCmaRequest;
}(MailtoFactory);

if (typeof module !== 'undefined' && module.exports) module.exports = PreferredReaCmaRequest;else if (typeof window !== 'undefined') window.PreferredReaCmaRequest = PreferredReaCmaRequest;

var RecommendedReaCmaRequest = function (_MailtoFactory3) {
  _inherits(RecommendedReaCmaRequest, _MailtoFactory3);

  function RecommendedReaCmaRequest(options) {
    _classCallCheck(this, RecommendedReaCmaRequest);

    return _possibleConstructorReturn(this, (RecommendedReaCmaRequest.__proto__ || Object.getPrototypeOf(RecommendedReaCmaRequest)).call(this, options));
  }

  _createClass(RecommendedReaCmaRequest, [{
    key: 'homeValue',
    value: function homeValue() {
      _.get(this.home, 'metadata.homeValue');
    }
  }, {
    key: '_to',
    value: function _to() {
      return '';
    }
  }, {
    key: '_subject',
    value: function _subject() {
      return 'Looking for a CMA for my client';
    }
  }, {
    key: '_body',
    value: function _body() {

      return 'Hello,\n\nA client of mine, ' + this.user.first_name + ' ' + this.user.last_name + ', has asked me (through Homebot) to provide them with a new estimated value of their home.  I have the option of picking someone to provide a CMA and I thought you might be interested.  It\'s a great opportunity to get to know a potential new client.  And, of course, I\'ll appreciate it.  If you are not interested, just let me know and I\'ll keep working my network for someone else who knows the area.\n\nHomebot makes this super easy for us both.  Once you have a new value, give me a call or email with the new value (and range if possible) and then I\'ll update ' + this.user.first_name + '\'s Homebot.\n\nThe details:\n\n' + this.$filter('clientNamesForwards')(this.home) + '\n- ' + this.helpers.displayAddress(this.home.address) + '\n- Last sold: ' + this.$filter('moment')(this.home.soldDate, 'MMMM, YYYY') + '\n' + this._estimateBullet() + '\n' + this._updatesBullet() + '\n\n' + this.user.first_name + '\'s phone: ' + this.$filter('phone')(this.user.mobile) + '\nEmail: ' + this.user.email + '\n\nLet me know what you think the value is!\n\n' + this.agent.first_name + ' ' + this.agent.last_name + '\nDon\'t hesitate to call me with questions: ' + this.$filter('phone')(this.$filter('mobile')(this.agent.phones)) + '\n\n\nP.S. You can learn more about homebot here: http://homebot.ai/cma';
    }
  }, {
    key: '_updatesBullet',
    value: function _updatesBullet() {
      if (!this.home.answers.homeUpdatedDescription) return '';

      return '- Updates they made to the home: "' + this.home.answers.homeUpdatedDescription + '"';
    }
  }, {
    key: '_estimateBullet',
    value: function _estimateBullet() {
      if (!this.home.answers.isEstimateCorrect) return '';

      return '- They believe that ' + this.$filter('money')(this.homeValue()) + ' is ' + this.$filter('estimateCorrect')(this.home.answers.isEstimateCorrect) + '.';
    }
  }]);

  return RecommendedReaCmaRequest;
}(MailtoFactory);

if (typeof module !== 'undefined' && module.exports) module.exports = RecommendedReaCmaRequest;else if (typeof window !== 'undefined') window.RecommendedReaCmaRequest = RecommendedReaCmaRequest;

if (typeof require !== 'undefined') {
  MailtoFactory = require('../mailtos/mailto-factory.js');
  _ = require('lodash');
}

var SponsorAgentInviteMailtoString = function (_MailtoFactory4) {
  _inherits(SponsorAgentInviteMailtoString, _MailtoFactory4);

  function SponsorAgentInviteMailtoString(options) {
    _classCallCheck(this, SponsorAgentInviteMailtoString);

    if (!options.agent) console.warn('Agent is required for mailto.');

    return _possibleConstructorReturn(this, (SponsorAgentInviteMailtoString.__proto__ || Object.getPrototypeOf(SponsorAgentInviteMailtoString)).call(this, options));
  }

  _createClass(SponsorAgentInviteMailtoString, [{
    key: '_to',
    value: function _to() {
      return '';
    }
  }, {
    key: '_subject',
    value: function _subject() {
      return 'I\'ve been trying out Homebot';
    }
  }, {
    key: '_getClientNamesForSubject',
    value: function _getClientNamesForSubject() {
      return this._getClientNames()[0];
    }
  }, {
    key: '_getClientNamesForBody',
    value: function _getClientNamesForBody() {
      return this._getClientNames().slice(0, 5).join(', ');
    }
  }, {
    key: '_getClientNames',
    value: function _getClientNames() {
      return this.rea.homes.map(function (home) {
        return home.users[0].first_name + ' ' + home.users[0].last_name;
      });
    }
  }, {
    key: '_body',
    value: function _body() {
      return 'Hello,\n\nI\'m providing a new service called Homebot to all of my clients (and they love it). It monitors their home value, loans, and market conditions to optimize home finance decisions (e.g. when to refi, when to buy/sell/rent, etc).\n\nThere\'s a version for real estate agents now and if you\'re interested, I\'d be happy to co-sponsor it for you!\n\nClick on this link to see what it looks like and sign up (http://get.homebotapp.com/agent/).\n\nOr give me a call to see it or ask questions!\n\n' + this.agent.first_name + ' ' + this.agent.last_name;
    }
  }]);

  return SponsorAgentInviteMailtoString;
}(MailtoFactory);

if (typeof module !== 'undefined' && module.exports) module.exports = SponsorAgentInviteMailtoString;else if (typeof window !== 'undefined') window.SponsorAgentInviteMailtoString = SponsorAgentInviteMailtoString;

angular.module('admin').config(['$stateProvider', function ($stateProvider) {

  var authenticated = ['SessionService', '$q', 'AuthResolver', function (SessionService, $q, AuthResolver) {
    if (SessionService.isLoggedIn()) return AuthResolver.identifyUser();else return $q.reject();
  }];

  $stateProvider.state('admins', {
    abstract: true,
    url: '/admins',
    templateUrl: '/admin/templates/pages/admins.html'
  });

  $stateProvider.state('admins.main', {
    url: '',
    controller: 'AdminsCtrl',
    templateUrl: '/admin/templates/pages/admins-main.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('admins.signups', {
    url: '/signups',
    controller: 'AdminsCtrl',
    templateUrl: '/admin/templates/admins-signups.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('admins.data', {
    abstract: true,
    url: '/data',
    controller: 'AdminsCtrl',
    templateUrl: '/admin/templates/pages/admins-data.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('admins.data.rates', {
    url: '/',
    controller: 'AdminsCtrl',
    templateUrl: '/admin/templates/pages/admins-data.rates.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('admins.agentSearch', {
    url: '/agent-search',
    controller: 'AgentsCtrl',
    templateUrl: '/admin/templates/agents-all.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('admins.agentBKSearch', {
    url: '/agent-bk-search',
    controller: 'AgentsCtrl',
    templateUrl: '/admin/templates/agents-bk-all.html',
    resolve: {
      authenticated: authenticated
    }
  });
}]);

angular.module('admin').config(['$stateProvider', 'APP_CONFIG', function ($stateProvider, APP_CONFIG) {

  var authenticated = ['SessionService', '$q', 'AuthResolver', function (SessionService, $q, AuthResolver) {
    if (SessionService.isLoggedIn()) return AuthResolver.identifyUser();else return $q.reject();
  }];

  $stateProvider.state('agent', {
    abstract: true,
    url: '/agent/:id',
    templateUrl: '/admin/templates/pages/agent.html'
  });

  $stateProvider.state('agent.stream', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/activity',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.clients', {
    url: '/clients',
    controller: 'AgentClientListCtrl',
    templateUrl: '/admin/templates/pages/agent-all-clients.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.clients.page', {
    url: '/page/:page',
    controller: 'AgentClientListCtrl',
    templateUrl: '/admin/templates/pages/agent-all-clients.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.clients.unsent', {
    url: '/unsent',
    controller: 'AgentClientListCtrl',
    templateUrl: '/admin/templates/pages/agent-all-clients.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.clients.needsCMA', {
    url: '/needs-cma',
    controller: 'AgentClientListCtrl',
    templateUrl: '/admin/templates/pages/agent-all-clients.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.clients.sharedClients', {
    url: '/shared-clients',
    controller: 'AgentClientListCtrl',
    templateUrl: '/admin/templates/pages/agent-all-clients.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.clients.invited', {
    url: '/invited',
    controller: 'AgentClientListCtrl',
    templateUrl: '/admin/templates/pages/agent-all-clients.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.newClients', {
    abstract: true,
    url: '/new-clients',
    templateUrl: '/admin/templates/pages/agent-new-clients.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.newClients.addOne', {
    url: '',
    controller: 'AgentNewClientCtrl',
    templateUrl: '/admin/templates/pages/agent-new-client.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.newClients.import', {
    url: '/import',
    controller: 'AgentImportClientsCtrl',
    templateUrl: '/admin/templates/pages/agent-import.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.sponsors', {
    url: '/sponsors',
    controller: 'AgentSponsorsCtrl',
    templateUrl: '/admin/templates/pages/agent-sponsors.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.realEstateAgents', {
    url: '/real-estate-agents',
    controller: 'AgentRealEstateAgentsCtrl',
    templateUrl: '/admin/templates/pages/agent-real-estate-agents.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.realEstateAgents.sponsoredAgent', {
    url: '/sponsored-agent/:sponsoredAgentId',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.realEstateAgents.detail', {
    url: '/detail/:mlsset',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.homeDetail', {
    url: '/home-detail/:homeId?clientId',
    controller: 'AgentHomeDetailCtrl',
    templateUrl: '/admin/templates/pages/agent-home-detail.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.adminGroups', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/company/{groupId}/users',
    external: true,
    params: {
      groupId: null
    },
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.edit', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/profile',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.new-features', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/profile/new-features',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.client-issues', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/issues',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.client-leads', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/leads',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.billing-info', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/profile/billing-info',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.agents', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/agents',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.buyers', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/buyers',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.clients.activity', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/activity',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.clients.homeowners', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/homeowners',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.clients.homeowners.needsCMA', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/homeowners/needs-cma',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.clients.homeowners.leads', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/homeowners/leads',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.clients.new', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/clients/new',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.customize', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/customize/power-ups',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.sponsor', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/sponsor',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.homePreview', {
    externalUrl: APP_CONFIG.CLIENTS_FRONTEND_URL + '/reports/home/{homeId}?cct=true',
    external: true,
    params: {
      homeId: null
    },
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.homePreviewForClientRefi', {
    externalUrl: APP_CONFIG.CLIENTS_FRONTEND_URL + '/reports/{clientId}/home/{homeId}?cct=true#RefiSection',
    external: true,
    params: {
      homeId: null,
      clientId: null
    },
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.billing', {
    url: '/billing',
    controller: 'AgentBillingCtrl',
    data: {
      pageTitle: 'Billing Information',
      back: 'agent.clients'
    },
    templateUrl: '/admin/templates/pages/agent-billing.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.share', {
    externalUrl: APP_CONFIG.MAINSTREET_URL + '/share',
    external: true,
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('agent.onboarding', {
    external: true,
    externalUrl: APP_CONFIG.MAINSTREET_URL
  });
}]);

angular.module('admin').config(['$stateProvider', function ($stateProvider) {

  var authenticated = ['SessionService', '$q', 'AuthResolver', function (SessionService, $q, AuthResolver) {
    if (SessionService.isLoggedIn()) return AuthResolver.identifyUser();else return $q.reject();
  }];

  $stateProvider.state('agents', {
    abstract: true,
    url: '/agents/:officeId',
    templateUrl: '/admin/templates/pages/agents.html'
  });

  $stateProvider.state('agents.all', {
    url: '',
    controller: 'AgentsCtrl',
    templateUrl: '/admin/templates/agents-all.html',
    resolve: {
      authenticated: authenticated
    }
  });
}]);

angular.module('admin').config(['$stateProvider', 'APP_CONFIG', function ($stateProvider, APP_CONFIG) {

  var clearSession = ['SessionService', function (SessionService) {
    return SessionService.clear();
  }];

  $stateProvider.state('login', {
    external: true,
    externalUrl: APP_CONFIG.LOGIN_URL,
    waitForResolve: true,
    url: '/login',
    resolve: {
      clearSession: clearSession
    }
  });

  $stateProvider.state('start', {
    url: '/start',
    controller: 'StartCtrl',
    template: '\n        <div class="content-main">\n          <div class="full-page-notice">\n            <div class="full-page-notice__body">\n              <div class="section-loader notice">\n                <i class="icon icon-ellipsis-h icon-spin"></i>\n              </div>\n            </div>\n          </div>\n        </div>\n      '
  });

  $stateProvider.state('logout', {
    external: true,
    externalUrl: APP_CONFIG.LOGOUT_URL,
    waitForResolve: true,
    url: '/logout',
    resolve: {
      clearSession: clearSession
    }
  });

  $stateProvider.state('paragonLogin', {
    url: '/paragon-login',
    templateUrl: '/admin/templates/pages/paragon-login.html'
  });
}]);

angular.module('admin').config(['$stateProvider', function ($stateProvider) {

  var authenticated = ['SessionService', '$q', 'AuthResolver', function (SessionService, $q, AuthResolver) {
    if (SessionService.isLoggedIn()) return AuthResolver.identifyUser();else return $q.reject();
  }];

  $stateProvider.state('offices', {
    abstract: true,
    url: '/offices/:officeId',
    templateUrl: '/admin/templates/pages/offices.html'
  });

  $stateProvider.state('offices.all', {
    url: '',
    controller: 'OfficesCtrl',
    templateUrl: '/admin/templates/pages/offices-all.html',
    resolve: {
      authenticated: authenticated
    }
  });

  $stateProvider.state('offices.stream', {
    url: '/stream',
    controller: 'OfficesStreamCtrl',
    templateUrl: '/admin/templates/pages/stream-basic.html',
    resolve: {
      authenticated: authenticated
    }
  });
}]);

angular.module('admin').factory('AuthForwarder', ['$cookies', '$state', 'AccountService', 'SessionService', 'APP_CONFIG', function ($cookies, $state, AccountService, SessionService, APP_CONFIG) {
  var COOKIE_NAME = 'redirectAfterAuthSuccess';

  var service = {
    forwardAfterLogin: function forwardAfterLogin() {
      var forwardState = $cookies.getObject(COOKIE_NAME);

      if (forwardState) {
        $cookies.remove(COOKIE_NAME);

        // disable forwarder while we fix login issues
        // if(forwardState.name.indexOf('login') !== -1 && forwardState.name.indexOf('start') !== -1) // temporary, we can delete this line soon, but leave next line
        //   $state.go(forwardState.name, forwardState.params);

        // return;
      }

      if (AccountService.getAgent('state') === 'active') {
        $state.go('agent.stream', { id: AccountService.getAgentId() });
      } else {
        $state.go('agent.onboarding');
      }
    },


    // if a user has a bad token and gets sent to the login
    // save the state they were trying to access as a cookie
    setForwardState: function setForwardState(url) {
      if (url && url.indexOf('login') === -1 && url.indexOf('start') === -1) {
        $cookies.putObject(COOKIE_NAME, url, {
          domain: APP_CONFIG.COOKIE_DOMAIN,
          path: '/',
          expires: moment().add(2, 'hours').format()
        });
      }
    }
  };

  return service;
}]);

angular.module('admin.services').service('AuthResolver', ['API_VARS', 'AccountService', 'AgentService', function (API_VARS, AccountService, AgentService) {
  var currentUser = void 0;
  var fetchCurrentUser = AgentService.getCurrentUser().then(function (user) {
    AccountService.set(user);
    currentUser = user;
    return user;
  });

  return {
    identifyUser: function identifyUser() {
      if (currentUser) {
        return Promise.resolve(currentUser);
      } else {
        return fetchCurrentUser;
      }
    }
  };
}]);

angular.module('admin.services').factory('RecurlyTokenService', [function () {
  return {
    fetchToken: function fetchToken(htmlFormElement) {
      return new Promise(function (resolve, reject) {
        recurly.token(htmlFormElement, function (err, token) {
          if (err) return reject(err);

          if (!token.id) return reject('Unable to get credit card authorization.');

          resolve(token.id);
        });
      });
    }
  };
}]);

angular.module('admin.directives').directive('avmCmaDisplay', ['Dictionary', function (Dictionary) {
  return {
    controllerAs: 'cmaCtrl',
    bindToController: {
      agent: '=',
      cmaAction: '&',
      home: '=',
      requester: '='
    },
    scope: {},
    restrict: 'AE',
    templateUrl: function templateUrl(el, attrs) {
      return '/admin/templates/partials/cma/' + attrs.template + '.html';
    },

    controller: function controller() {
      var ctrl = this;
      var dictionary = new Dictionary();

      ctrl.homeValue = _.get(ctrl.home, 'metadata.homeValue');
      ctrl.hasTuneFeature = true;
      ctrl.lookup = function (prop, args) {
        return dictionary[prop](ctrl.home, args);
      };
    }
  };
}]);

angular.module('admin.directives').directive('cmaEntry', ['HelperService', 'HomeService', 'HomeActivity', 'PageNotificationService', function (helpers, HomeService, HomeActivity, PageNotificationService) {
  return {
    controllerAs: 'cmaEntryCtrl',
    bindToController: {
      agent: '=',
      preferredRea: '=',
      requester: '=',
      onCancel: '&',
      homeId: '@',
      onSave: '&'
    },
    scope: {},
    restrict: 'AE',
    templateUrl: '/admin/templates/partials/cma/cma-entry.html',

    controller: function controller() {
      var ctrl = this;

      ctrl.save = function () {
        var cma = ctrl.parseForSave();
        ctrl.loading = true;

        HomeService.agentCMA(ctrl.homeId, cma).then(function () {
          return ctrl.sendCMANotification();
        }).then(function () {
          ctrl.onSave();
          ctrl.loading = false;
        }).catch(function (e) {
          PageNotificationService.error(e.message);
        });
      };

      // TODO: move to api
      ctrl.sendCMANotification = function () {
        if (!ctrl.shouldSendNotification()) return Promise.resolve();

        return HomeActivity.trackHome({
          source: 'agent',
          event: 'cma-notify-client',
          userId: ctrl.requester.id,
          homeId: ctrl.homeId,
          agentId: ctrl.agent.id
        });
      };

      ctrl.shouldSendNotification = function () {
        if (ctrl.requester.digestHasBeenSent) return true;

        return false;
      };

      ctrl.parseForSave = function () {
        var cma = _.cloneDeep(ctrl.cma);

        cma.amount = helpers.getFloatFromString(cma.amount);
        cma.high = helpers.getFloatFromString(cma.high);
        cma.low = helpers.getFloatFromString(cma.low);
        cma.requesterId = ctrl.requester.id;
        cma.source = ctrl.cmaWasPreferredRea ? 'mls-rea' : 'agent';
        cma.sourceId = ctrl.cmaWasPreferredRea ? ctrl.preferredRea.id : ctrl.agent.id;
        cma.agentId = ctrl.agent.id;

        return cma;
      };

      ctrl.setup = function () {
        if (ctrl.preferredRea) ctrl.cmaWasPreferredRea = true;
      };

      ctrl.setup();
    },

    link: function link($scope, el, attrs, ctrl) {
      $scope.$watch('cmaEntryCtrl.preferredRea', ctrl.setup);
    }
  };
}]);

angular.module('admin.directives').directive('mailto', ['MailtoService', function (MailtoService) {
  return {
    controllerAs: 'mailToCtrl',
    bindToController: {
      agent: '=',
      home: '=',
      rea: '=',
      requester: '=',
      emailType: '@'
    },
    scope: {},
    restrict: 'A',

    controller: function controller() {
      var ctrl = this;

      var options = {
        home: ctrl.home,
        agent: ctrl.agent,
        user: ctrl.requester,
        rea: ctrl.rea
      };

      var mailtoBuilder = MailtoService.create(ctrl.emailType, options);

      ctrl.getMailTo = function () {
        return mailtoBuilder.buildMailto();
      };
    },

    link: function link($scope, el, attrs, ctrl) {
      el[0].setAttribute('href', '');

      el.on('click', function () {
        el[0].setAttribute('href', 'mailto:' + ctrl.getMailTo());
      });
    }
  };
}]);